// --------------------------------------------------------------------
// <auto-generated>
//     This code was generated by codegen-vue-apollo
//
//     Changes to this file may cause incorrect behavior
//     and will be lost if the code is regenerated.
// </auto-generated>
// --------------------------------------------------------------------

/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import { useQuery, UseQueryOptions, useSubscription, UseSubscriptionOptions } from '@vue/apollo-composable';
import { ref, Ref, isRef, computed, ComputedRef } from 'vue';
import { DocumentNode } from 'graphql';
import { get } from '@vueuse/core';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;

type QueryType<T> = { query: T }

/* Check if a type is a union, and return true if so, otherwise false. */
type IsUnion<T, U = T> = U extends any ? ([T] extends [U] ? false : true) : never
/* Extracts an inner type if T has a single key K, otherwise it returns T. */
type ExtractSingleKey<T, K extends keyof T = keyof T, KWithoutTypename extends K = Exclude<K, '__typename'>> = IsUnion<KWithoutTypename> extends true ? T : T[KWithoutTypename]

const isFunction = (value: unknown): value is (...args: unknown[]) => unknown => typeof value === 'function';
const isPrimitive = (v: unknown) => v !== Object(v);
const autoPick = <T>(value: T): ExtractSingleKey<T> => {
  if(isPrimitive(value)) return value;
  const keys = Object.keys(value)
  if (keys.length === 1) {
    // Automatically take the only key in result data
    return value[keys[0] as keyof TResult]
  } else {
    // Return entire result data
    return value
  }
}

const queryVariables = <T>(variables: T | Ref<T> | ReactiveFunction<T>): ComputedRef<T> => computed(() => {
  if (isRef(variables)) return variables.value;
  if (isFunction(variables)) return variables();
  return variables;
})

export function useApolloQuery<TResult, TVariable>(
document: DocumentNode,
defaultOptions: UseQueryOptions<TResult, QueryType<TVariable>> | Ref<UseQueryOptions<TResult, QueryType<TVariable>>> | ReactiveFunction<UseQueryOptions<TResult, QueryType<TVariable>>>,
noVariable = false) {
  return (variables: TVariable | Ref<TVariable> | ReactiveFunction<TVariable>, queryOptions: UseQueryOptions<TResult, QueryType<TVariable>> | Ref<UseQueryOptions<TResult, QueryType<TVariable>>> | ReactiveFunction<UseQueryOptions<TResult, QueryType<TVariable>>> = {}) => {
    const options = () => ({
        ...get(defaultOptions),
        ...get(queryOptions),
    });
    const queryReturn = noVariable
      ? useQuery<TResult, null>(document, null, options)
      : useQuery<TResult, QueryType<TVariable>>(document, queryVariables(variables), options);

    const result = computed<ExtractSingleKey<TResult> | undefined>(() => autoPick(queryReturn.result.value));
    type PickedResultType = typeof result['value'];

    const loaded = ref(false);
    const onResultCallbacks: ((result: PickedResultType) => void)[] = [];

    const oldOnResult = queryReturn.onResult
    oldOnResult((result) => {
        loaded.value = true;
        const pickedResult = autoPick(result.data);
        onResultCallbacks.forEach(cb => cb(pickedResult));
    });
    const onResult = (fn: (result: PickedResultType) => void) => {
        onResultCallbacks.push(fn);
    }

    return { ...queryReturn, onResult, loaded, result };
  };
}

export function useApolloSubscription<TResult, TVariable>(document: DocumentNode, defaultOptions: UseSubscriptionOptions<TResult, QueryType<TVariable>> | Ref<UseSubscriptionOptions<TResult, QueryType<TVariable>>> | ReactiveFunction<UseSubscriptionOptions<TResult, QueryType<TVariable>>>, noVariable = false) {
  return (variables: TVariable | Ref<TVariable> | ReactiveFunction<TVariable>, queryOptions: UseSubscriptionOptions<TResult, QueryType<TVariable>> | Ref<UseSubscriptionOptions<TResult, QueryType<TVariable>>> | ReactiveFunction<UseSubscriptionOptions<TResult, QueryType<TVariable>>> = {}) => {
    const options = () => ({
        ...get(defaultOptions),
        ...get(queryOptions),
    });
    const { result: oldSubscription, onResult: oldOnSubscription, ...subscriptionReturn} = noVariable
      ? useSubscription<TResult, null>(document, null, options)
      : useSubscription<TResult, QueryType<TVariable>>(document, queryVariables(variables), options);

    const subscription = computed<ExtractSingleKey<TResult> | undefined>(() => autoPick(oldSubscription.value));
    type PickedResultType = typeof subscription['value'];

    const loaded = ref(false);
    const onResultCallbacks: ((result: PickedResultType) => void)[] = [];

    oldOnSubscription((result) => {
      loaded.value = true;
      const pickedResult = autoPick(result.data);
      onResultCallbacks.forEach(cb => cb(pickedResult));
    });
    const onSubscription = (fn: (result: PickedResultType) => void) => {
      onResultCallbacks.push(fn);
    };

    return { ...subscriptionReturn, loaded, onSubscription, subscription };
  };
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: string;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  /**
   * The `DateTimeOffset` scalar type represents a date, time and offset from UTC.
   * `DateTimeOffset` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
   */
  DateTimeOffset: any;
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by ECMA-404 */
  JSON: any;
  /** The `Milliseconds` scalar type represents a period of time represented as the total number of milliseconds. */
  Milliseconds: any;
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds. */
  Seconds: any;
};




export type BetBuilderEventExistsInputType = {
  id: Scalars['Int'];
};

export type BetBuilderEventInputType = {
  id: Scalars['Int'];
};

/** Bet Builder event information */
export type BetBuilderEventType = {
  matchId: Scalars['Int'];
  markets: Array<BetBuilderMarketType>;
};

/** Bet Builder market information */
export type BetBuilderMarketType = {
  matchMarketId: Scalars['Int'];
  marketType: BetBuilderMarketTypeType;
  matchStatType: BetBuilderMatchStatType;
  displayType: EnumDisplayType;
  point: Scalars['Decimal'];
  selections: Array<BetBuilderSelectionType>;
  displayPriority: Scalars['Int'];
};

/** Bet Builder market type information */
export type BetBuilderMarketTypeType = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Bet Builder match stat type information */
export type BetBuilderMatchStatType = {
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** Bet Builder selection information */
export type BetBuilderSelectionType = {
  id: Scalars['Int'];
  selectionType: BetBuilderSelectionTypeType;
  status: EnumSelectionStatus;
};

/** Bet Builder selection type information */
export type BetBuilderSelectionTypeType = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Live Stream information for BetConstruct API */
export type BetConstructStreamType = {
  eventId: Scalars['Int'];
  allowedCountries: Array<Scalars['String']>;
  isPlaying: Scalars['Boolean'];
};

/** Live Stream information for BetGenius */
export type BetGeniusStreamType = {
  eventId: Scalars['Int'];
  allowedCountries: Array<Scalars['String']>;
  isPlaying: Scalars['Boolean'];
  providerEventId: Scalars['Int'];
};

/** Live score information from BetRadar provider */
export type BetRadarLiveScoreType = {
  gameHomeScore?: Maybe<Scalars['Int']>;
  gameAwayScore?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  matchStatus?: Maybe<Scalars['Int']>;
  setHomeScore?: Maybe<Scalars['Int']>;
  setAwayScore?: Maybe<Scalars['Int']>;
  totalHomeScore?: Maybe<Scalars['Int']>;
  totalAwayScore?: Maybe<Scalars['Int']>;
  inPlayInning?: Maybe<Scalars['String']>;
  inPlayPeriod?: Maybe<Scalars['String']>;
};

/** Live Stream information for AudioVisual API */
export type BetRadarStreamType = {
  eventId: Scalars['Int'];
  streamId: Scalars['Int'];
  streamStatus: Scalars['String'];
  allowedCountries: Array<Scalars['String']>;
};

export const enum CacheControlScope {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
};

/** Reference to a content group translation entry */
export type ContentTranslationType = {
  id: Scalars['Int'];
  group: EnumContentGroupType;
};

/** Live score information for cricket event */
export type CricketLiveScoreType = {
  matchId: Scalars['Int'];
  homeScore: Scalars['Int'];
  awayScore: Scalars['Int'];
  homeDismissals: Scalars['Int'];
  awayDismissals: Scalars['Int'];
  innings: Scalars['Int'];
  over: Scalars['Int'];
  delivery: Scalars['Int'];
};





export const enum EnumContentGroupType {
  Unknown = 'Unknown',
  League = 'League',
  Team = 'Team',
  BetType = 'BetType',
  SportType = 'SportType',
  AdminShortName = 'AdminShortName',
  SportShortName = 'SportShortName',
  Country = 'Country',
  TimeZone = 'TimeZone',
  NewBetType = 'NewBetType',
  BetTypeGroup = 'BetTypeGroup',
  HomeExt = 'HomeExt',
  AwayExt = 'AwayExt',
  LeagueInfo = 'LeagueInfo',
  GamesName = 'GamesName',
  MarketDetails = 'MarketDetails',
  Market = 'Market'
};

export const enum EnumDisplayType {
  Unknown = 'Unknown',
  Handicap = 'Handicap',
  OddEven = 'OddEven',
  OverUnder = 'OverUnder',
  CorrectScore = 'CorrectScore',
  _1X2 = '_1X2',
  TotalGoal = 'TotalGoal',
  FhHandicap = 'FhHandicap',
  Fh1X2 = 'Fh1X2',
  FhOverUnder = 'FhOverUnder',
  Htft = 'Htft',
  MoneyLine = 'MoneyLine',
  FhOddEven = 'FhOddEven',
  Fglg = 'Fglg',
  FhCorrectScore = 'FhCorrectScore',
  DoubleChance = 'DoubleChance',
  LiveScore = 'LiveScore',
  FhLiveScore = 'FhLiveScore',
  ShCorrectScore = 'ShCorrectScore',
  Game = 'Game',
  OutRight = 'OutRight',
  MixParlay = 'MixParlay'
};

/** Event date type of event to filter with */
export const enum EnumEventDateFilterType {
  All = 'All',
  Today = 'Today',
  TodayExpanded = 'TodayExpanded',
  Plus1 = 'Plus1',
  Plus2 = 'Plus2',
  Plus2Over = 'Plus2Over',
  Plus3 = 'Plus3',
  Plus4 = 'Plus4',
  Plus4Over = 'Plus4Over',
  Plus5 = 'Plus5',
  Plus6 = 'Plus6',
  Plus6Over = 'Plus6Over',
  EarlyMarket = 'EarlyMarket'
};

export const enum EnumEventFieldOrder {
  eventCode = 'eventCode',
  eventDate = 'eventDate',
  hasStatistics = 'hasStatistics',
  isLive = 'isLive',
  liveDisplayLines = 'liveDisplayLines',
  liveMixParlayOddsCount = 'liveMixParlayOddsCount',
  liveNbtOddsCount = 'liveNbtOddsCount',
  liveOddsCount = 'liveOddsCount',
  liveCourtMatchId = 'liveCourtMatchId',
  mixParlayOddsCount = 'mixParlayOddsCount',
  nonLiveNbtOddsCount = 'nonLiveNbtOddsCount',
  nonLiveOddsCount = 'nonLiveOddsCount',
  realKickoffTime = 'realKickoffTime',
  showTime = 'showTime'
};

/** Event status */
export const enum EnumEventStatus {
  Unknown = 'Unknown',
  Running = 'Running',
  Internal = 'Internal',
  Closed = 'Closed',
  Completed = 'Completed'
};

/** Event handicap type */
export const enum EnumHandicapType {
  Unknown = 'Unknown',
  Home = 'Home',
  Away = 'Away',
  None = 'None'
};

/** reference TiEnumLanguageType */
export const enum EnumLanguageType {
  EN = 'EN',
  ZH_TW = 'ZH_TW',
  ZH_CN = 'ZH_CN',
  JA_JP = 'JA_JP',
  KO_KR = 'KO_KR',
  TH_TH = 'TH_TH',
  VI_VN = 'VI_VN',
  ID_ID = 'ID_ID',
  DE_DE = 'DE_DE',
  ES_ES = 'ES_ES',
  MY_MM = 'MY_MM',
  FR_FR = 'FR_FR',
  RU_RU = 'RU_RU',
  PT_PT = 'PT_PT',
  PT_BR = 'PT_BR',
  ZH_CW = 'ZH_CW',
  HI_IN = 'HI_IN',
  TA_IN = 'TA_IN',
  KM_KH = 'KM_KH',
  BN_BD = 'BN_BD',
  MS_MY = 'MS_MY'
};

/** Token versions that price with a marked odds token. DL is not a marked version. */
export const enum EnumMarkedTokenVersion {
  SB = 'SB',
  SM = 'SM',
  SS = 'SS',
  OB = 'OB',
  OM = 'OM',
  OS = 'OS'
};

/** Market type of odds */
export const enum EnumMarketType {
  Unknown = 'Unknown',
  Handicap = 'Handicap',
  OddEven = 'OddEven',
  OverUnder = 'OverUnder',
  CorrectScore = 'CorrectScore',
  _1X2 = '_1X2',
  TotalGoal = 'TotalGoal',
  FH_Handicap = 'FH_Handicap',
  FH_1X2 = 'FH_1X2',
  FH_OverUnder = 'FH_OverUnder',
  HTFT = 'HTFT',
  MoneyLine = 'MoneyLine',
  FH_OddEven = 'FH_OddEven',
  FGLG = 'FGLG',
  FH_CorrectScore = 'FH_CorrectScore',
  DoubleChance = 'DoubleChance',
  LiveScore = 'LiveScore',
  FH_LiveScore = 'FH_LiveScore',
  Game = 'Game',
  OutRight = 'OutRight',
  MixParlay = 'MixParlay',
  SH_CorrectScore = 'SH_CorrectScore'
};

/** The category to filter odds, `All` is all odds, and `MixParlay` for the only events that have `Mix Parlay` odds. *Filters are done in Gambit.* */
export const enum EnumOddsCategoryType {
  All = 'All',
  MixParlay = 'MixParlay'
};

export const enum EnumOddsFieldOrder {
  id = 'id',
  eventResult = 'eventResult',
  sport = 'sport',
  betCondition = 'betCondition',
  isLive = 'isLive',
  hasMixParlay = 'hasMixParlay',
  marketType = 'marketType',
  marketId = 'marketId',
  maxBet = 'maxBet',
  sortOrder = 'sortOrder',
  point = 'point',
  prices = 'prices',
  status = 'status'
};

/** Odds status */
export const enum EnumOddsStatus {
  Unknown = 'Unknown',
  Running = 'Running',
  Suspend = 'Suspend',
  Internal = 'Internal',
  Closed = 'Closed'
};

/** Odds display style for market prices */
export const enum EnumOddsStyle {
  Unknown = 'Unknown',
  Malay = 'Malay',
  Hk = 'Hk',
  Indo = 'Indo',
  Euro = 'Euro'
};

export const enum EnumPopularEventGroup {
  All = 'All',
  India = 'India'
};

/** The market page type to filter events or odds. *Data are already pre-filtered in GambitCache for performance.* */
export const enum EnumPresetFilterType {
  All = 'All',
  Live = 'Live',
  NonLive = 'NonLive',
  MixParlay = 'MixParlay',
  OETG = 'OETG',
  CorrectScore = 'CorrectScore',
  HTFT = 'HTFT',
  _1X2DC = '_1X2DC',
  FGLG = 'FGLG',
  Outright = 'Outright'
};

/** The price style for displaying `Price` */
export const enum EnumPriceStyle {
  Malay = 'Malay',
  HK = 'HK',
  Indo = 'Indo',
  Euro = 'Euro'
};

/** Provider enumeration */
export const enum EnumProvider {
  Unknown = 'Unknown',
  Manual = 'Manual',
  Fifa = 'Fifa'
};

export const enum EnumSelectionStatus {
  Unknown = 'Unknown',
  Running = 'Running',
  Suspended = 'Suspended',
  Internal = 'Internal',
  Closed = 'Closed'
};

/** The sport type of event */
export const enum EnumSportType {
  Soccer = 'Soccer',
  Basketball = 'Basketball',
  Football = 'Football',
  Ice_Hockey = 'Ice_Hockey',
  Badminton = 'Badminton',
  Pool = 'Pool',
  Motor_Sport = 'Motor_Sport',
  Tennis = 'Tennis',
  Baseball = 'Baseball',
  Volleyball = 'Volleyball',
  Others = 'Others',
  Golf = 'Golf',
  Boxing = 'Boxing',
  Cricket = 'Cricket',
  Table_Tennis = 'Table_Tennis',
  Rugby = 'Rugby',
  Handball = 'Handball',
  Cycling = 'Cycling',
  Athletics = 'Athletics',
  Beach_Soccer = 'Beach_Soccer',
  Futsal = 'Futsal',
  Entertainment = 'Entertainment',
  Financial = 'Financial',
  Darts = 'Darts',
  Olympic = 'Olympic',
  Lacrosse = 'Lacrosse',
  Water_Polo = 'Water_Polo',
  Winter_Sports = 'Winter_Sports',
  Squash = 'Squash',
  General_Hockey = 'General_Hockey',
  Mixed_Martial_Arts = 'Mixed_Martial_Arts',
  E_Sports = 'E_Sports',
  Gaelic_Football = 'Gaelic_Football',
  Hurling = 'Hurling',
  Muay_Thai = 'Muay_Thai',
  Aussie_Rules_Football = 'Aussie_Rules_Football',
  Bandy = 'Bandy',
  Winter_Olympic = 'Winter_Olympic',
  Beach_Volleyball = 'Beach_Volleyball'
};

/** Team type */
export const enum EnumTeamType {
  Player = 'Player',
  Team = 'Team',
  National = 'National'
};

/** The time zone is used for filtering events based on time zone */
export const enum EnumTimeZoneType {
  /** UTC-4 */
  UTC__4 = 'UTC__4',
  /** UTC+7 */
  UTC_7 = 'UTC_7',
  /** UTC+8 */
  UTC_8 = 'UTC_8',
  /** UTC+9 */
  UTC_9 = 'UTC_9'
};

export const enum EnumTokenVersion {
  DL = 'DL',
  SB = 'SB',
  SM = 'SM',
  SS = 'SS',
  OB = 'OB',
  OM = 'OM',
  OS = 'OS'
};

/** Tournament size */
export const enum EnumTournamentSizeType {
  Big = 'Big',
  Medium = 'Medium',
  Small = 'Small'
};

/** Tournament stage enumeration */
export const enum EnumTournamentStage {
  Unknown = 'Unknown',
  Final = 'Final',
  ThirdPlace = 'ThirdPlace',
  SemiFinals = 'SemiFinals',
  QuarterFinals = 'QuarterFinals',
  RoundOf16 = 'RoundOf16',
  RoundOf32 = 'RoundOf32'
};

export const enum EnumWhatsHotType {
  Popular = 'Popular',
  SportType = 'SportType'
};

export type EventInputType = {
  id: Scalars['Int'];
  /**
   * To set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`.
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
};

/** EventListInputType information */
export type EventListInputType = {
  /** List of match ids */
  ids: Array<Scalars['Int']>;
  /**
   * To set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`.
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
};

export type EventOddsInputType = {
  id: Scalars['Int'];
  /** Optional Parameter, for filtering by oddsId only */
  oddsId?: Maybe<Scalars['Int']>;
  /** The filter to display odds */
  filter?: Maybe<EnumPresetFilterType>;
  /** MarketTypes to filter odds */
  marketTypes?: Maybe<Array<EnumMarketType>>;
  /** Market Group Ids to filter odds, not to be used with excludeMarketGroupIds */
  marketGroupIds?: Maybe<Array<Scalars['Int']>>;
  /** Market Group Ids to filter odds, not to be used with marketGroupIds */
  excludeMarketGroupIds?: Maybe<Array<Scalars['Int']>>;
  /**
   * The odds category to filter odds.
   * If `All` then show all odds, otherwise `MixParlay` will only show mix parlay odds.
   * Default is: `All`.
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  /** Odds price style to display the `Price` */
  priceStyle?: Maybe<EnumPriceStyle>;
  /** Token for odds query */
  oddsToken: Scalars['String'];
  /** Version of token format: DL, SM, SB, SS, OM, OB, or OS (default: DL) */
  version?: Maybe<EnumTokenVersion>;
};

/** Event result extra info */
export type EventResultExtraInfoType = {
  awayRedCards: Scalars['Int'];
  eventResultId: Scalars['Int'];
  extraFirstHalfDuration: Scalars['Int'];
  extraSecondHalfDuration: Scalars['Int'];
  firstHalfDuration: Scalars['Int'];
  homeRedCards: Scalars['Int'];
  injuryTime: Scalars['Int'];
  liveDisplayLines: Scalars['Int'];
  period: Scalars['Int'];
  periodStartTime: Scalars['Date'];
  periodStopTime: Scalars['Date'];
  secondHalfDuration: Scalars['Int'];
  /** @deprecated Use `EventType.stream.videoUrl` */
  videoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `EventType.stream.videoUrl` not null or empty */
  videoUrlStatus: Scalars['Boolean'];
  round: Scalars['Int'];
  isBreakTime: Scalars['Boolean'];
  statisticsUrl?: Maybe<Scalars['String']>;
};

/** Event result score information */
export type EventResultScoreType = {
  liveHomeScore: Scalars['Int'];
  liveAwayScore: Scalars['Int'];
};

/** Event result information */
export type EventResultType = {
  id: Scalars['Int'];
  eventId: Scalars['Int'];
  sport: EnumSportType;
  extraInfo?: Maybe<EventResultExtraInfoType>;
  fullTimeAwayScore: Scalars['Int'];
  fullTimeHomeScore: Scalars['Int'];
  halfTimeAwayScore: Scalars['Int'];
  halfTimeHomeScore: Scalars['Int'];
  isMixParlay: Scalars['Boolean'];
  kickoffTime: Scalars['Date'];
  liveAwayScore: Scalars['Int'];
  liveHandicapType: EnumHandicapType;
  liveHomeScore: Scalars['Int'];
  liveMixParlayHandicapType: EnumHandicapType;
  liveMixParlayOddsCount: Scalars['Int'];
  liveNbtOddsCount: Scalars['Int'];
  liveOddsCount: Scalars['Int'];
  marketGroup?: Maybe<MarketGroupType>;
  mixParlayHandicapType: EnumHandicapType;
  mixParlayOddsCount: Scalars['Int'];
  nonLiveHandicapType: EnumHandicapType;
  nonLiveNbtOddsCount: Scalars['Int'];
  status: EnumEventStatus;
};

/** Event information */
export type EventType = {
  id: Scalars['Int'];
  awayJersey: Scalars['String'];
  awayTeam?: Maybe<TeamType>;
  eventCode: Scalars['String'];
  eventDate: Scalars['Date'];
  hasStatistics: Scalars['Boolean'];
  homeJersey: Scalars['String'];
  homeTeam?: Maybe<TeamType>;
  /** If `liveDisplayLines` is > 0, then when having no live odds, the event still persisted */
  liveDisplayLines: Scalars['Int'];
  hasLiveOdds: Scalars['Boolean'];
  liveHandicapType: EnumHandicapType;
  liveMixParlayHandicapType: EnumHandicapType;
  liveMixParlayOddsCount: Scalars['Int'];
  liveNbtOddsCount: Scalars['Int'];
  liveOddsCount: Scalars['Int'];
  liveCourtMatchId: Scalars['Int'];
  mixParlayHandicapType: EnumHandicapType;
  mixParlayOddsCount: Scalars['Int'];
  /** @deprecated Use `stream.betRadar.streamId` */
  mobileStreamId: Scalars['Int'];
  /** @deprecated Use `stream.betRadar.streamStatus` */
  mobileStreamStatus: Scalars['String'];
  nonLiveHandicapType: EnumHandicapType;
  nonLiveNbtOddsCount: Scalars['Int'];
  nonLiveOddsCount: Scalars['Int'];
  /** Array of `marketGroupId:marketTypeId:oddsCount` */
  marketTypeCount: Array<Scalars['String']>;
  /** Dynamic market count from MongoDB (null on subscription updates — use dynamicMarketCount subscription) */
  dynamicMarketCount?: Maybe<Scalars['Int']>;
  /** UTC -4 */
  realKickoffTime: Scalars['Date'];
  /** UTC +8 */
  showTime: Scalars['String'];
  showTimeType: Scalars['Int'];
  tournament: TournamentType;
  tvChannel: Scalars['String'];
  tvChannels: Array<TvChannelType>;
  videoDisallowCountryList: Scalars['String'];
  eventResults: Array<EventResultType>;
  mainMarketEventResult: EventResultType;
  totalCornerScore?: Maybe<EventResultScoreType>;
  isLive: Scalars['Boolean'];
  stream?: Maybe<StreamType>;
  liveOutrightIds: Array<Scalars['Int']>;
  nonLiveOutrightIds: Array<Scalars['Int']>;
  isSimulation: Scalars['Boolean'];
  absKickoffTime: Scalars['Date'];
};


/** Event information */
export type EventTypeeventResultsArgs = {
  ids?: Maybe<Array<Scalars['Int']>>;
  betTypeGroupIds?: Maybe<Array<Scalars['Int']>>;
};

export type EventsByRegionsInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  filter: PresetFilterInputType;
  /**
   * The odds category to filter events.
   * If `All` then show all events, otherwise `MixParlay` will only show events that having `MixParlay` odds.
   * Also to set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  /** The time zone that will be base on to filter events, default is UTC-4 */
  timeZone?: Maybe<EnumTimeZoneType>;
  /** To filter events results by regions ids. */
  regionIds: Array<Scalars['Int']>;
};

export type EventsCountInfoQueryFilterType = {
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  presetFilter: EnumPresetFilterType;
  /** The date of event */
  date: EnumEventDateFilterType;
};

/** Events count information */
export type EventsCountInfoType = {
  queryFilter: EventsCountInfoQueryFilterType;
  eventCount: Scalars['Int'];
  liveEventCount: Scalars['Int'];
  simulationEventCount: Scalars['Int'];
  liveSimulationEventCount: Scalars['Int'];
  filterEFootballEventCount: Scalars['Int'];
  liveFilterEFootballEventCount: Scalars['Int'];
};

export type EventsCountInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /**
   * The odds category to filter events.
   * If `All` then show all events, otherwise `MixParlay` will only show events that having `MixParlay` odds.
   * Also to set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  filters: Array<PresetFilterInputType>;
  timeZone?: Maybe<EnumTimeZoneType>;
  /** To optionally filter events count results by event ids. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  eventIds?: Maybe<Array<Scalars['Int']>>;
  /** To optionally filter events count results by tournament ids. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  tournamentIds?: Maybe<Array<Scalars['Int']>>;
  /** To optionally filter outright tournaments count that start with tournament names. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  tournamentNames?: Maybe<Array<Scalars['String']>>;
  /** To optionally filter events count results by region ids. */
  regionIds?: Maybe<Array<Scalars['Int']>>;
};

export type EventsInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  filter: PresetFilterInputType;
  /**
   * The odds category to filter events.
   * If `All` then show all events, otherwise `MixParlay` will only show events that having `MixParlay` odds.
   * Also to set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  /** The time zone that will be base on to filter events, default is UTC-4 */
  timeZone?: Maybe<EnumTimeZoneType>;
  /** To optionally filter events results by event ids. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  eventIds?: Maybe<Array<Scalars['Int']>>;
  /** To optionally filter events results by tournament ids. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  tournamentIds?: Maybe<Array<Scalars['Int']>>;
  /** To optionally filter tournaments that start with tournament names. Will be filtered using `eventIds` OR `tournamentIds` OR `tournamentNames` */
  tournamentNames?: Maybe<Array<Scalars['String']>>;
};

/** Subscription payload, include `added` or `updated` events and `deleted` events if any */
export type EventsSubscriptionType = {
  updated: Array<EventType>;
  deleted: Array<Scalars['Int']>;
};

/** Live Stream information for GLive API */
export type GLiveStreamType = {
  eventId: Scalars['Int'];
  isPlaying: Scalars['Boolean'];
};

/** Team information within a tournament group */
export type GroupTeamType = {
  id: Scalars['Int'];
  teamName: Array<TranslationType>;
  countryName?: Maybe<Scalars['String']>;
  teamType: EnumTeamType;
  played: Scalars['Int'];
  won: Scalars['Int'];
  drawn: Scalars['Int'];
  lost: Scalars['Int'];
  goalDifference: Scalars['Int'];
  points: Scalars['Int'];
  ranking: Scalars['Int'];
  isQualified: Scalars['Boolean'];
};

/** Group information for tournament */
export type GroupType = {
  groupName: Scalars['String'];
  teamList: Array<GroupTeamType>;
};


/** Match information for knockout stages */
export type KnockoutMatchType = {
  datetime?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  matchNumber?: Maybe<Scalars['Int']>;
  homePlaceHolder?: Maybe<Scalars['String']>;
  awayPlaceHolder?: Maybe<Scalars['String']>;
  regularMatch?: Maybe<SboMatchType>;
  extraTimeMatch?: Maybe<SboMatchType>;
  penaltyMatch?: Maybe<SboMatchType>;
  homeTeam?: Maybe<TeamType>;
  awayTeam?: Maybe<TeamType>;
};

/** Knockout stage information */
export type KnockoutType = {
  stage: EnumTournamentStage;
  matchList: Array<KnockoutMatchType>;
};

/** Live score information for event */
export type LiveScoreInfoType = {
  sbo?: Maybe<SboLiveScoreType>;
  sdt?: Maybe<SdtLiveScoreType>;
  betConstruct?: Maybe<ThirdPartyLiveScoreType>;
  betRadar?: Maybe<BetRadarLiveScoreType>;
  cricket?: Maybe<CricketLiveScoreType>;
  betGenius?: Maybe<ThirdPartyLiveScoreType>;
  publishTime?: Maybe<Scalars['Date']>;
};

export type LiveScoreInputType = {
  id: Scalars['Int'];
};

export type LocalEventsInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  filter: PresetFilterInputType;
  /**
   * The odds category to filter events.
   * If `All` then show all events, otherwise `MixParlay` will only show events that having `MixParlay` odds.
   * Also to set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  /** The time zone that will be base on to filter events, default is UTC-4 */
  timeZone?: Maybe<EnumTimeZoneType>;
  /** Country code can filter events by country, could be: `ID`, `VN`, `TH`, etc */
  countryCode: Scalars['String'];
};

/** Market group information */
export type MarketGroupType = {
  id: Scalars['Int'];
  /** Dictionary of language to away extension */
  awayExtension: Array<TranslationType>;
  awayTemplate: Scalars['String'];
  displayPriority: Scalars['Int'];
  /** Dictionary of language to home extension */
  homeExtension: Array<TranslationType>;
  homeTemplate: Scalars['String'];
  isSingle: Scalars['Boolean'];
  isYesNo: Scalars['Boolean'];
  /** Dictionary of language to market group name */
  marketGroupName: Array<TranslationType>;
  scoringType: Scalars['Int'];
};

/** Price information for market selection */
export type MarketPrice = {
  value: Scalars['Decimal'];
  oddsStyle: EnumOddsStyle;
};

/** Market information for a match */
export type MarketType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  matchId: Scalars['Int'];
  marketTypeId: Scalars['Int'];
  isLive: Scalars['Boolean'];
  isSingle: Scalars['Boolean'];
  isSuspended: Scalars['Boolean'];
  isMixParlayAvailable: Scalars['Boolean'];
  matchStatTypeId: Scalars['Int'];
  displayPriority: Scalars['Int'];
  template: TemplateType;
  selections: Array<SelectionType>;
};

export type MarketsInputType = {
  matchId: Scalars['Int'];
  /** Whether to query live markets */
  isLive: Scalars['Boolean'];
};

/** Subscription payload for market changes, includes updated and deleted markets */
export type MarketsSubscriptionType = {
  updated: Array<MarketType>;
  deleted: Array<Scalars['Int']>;
};

/** Markets query with marked odds token. Only marked token versions (SB, SM, SS, OB, OM, OS) are accepted. */
export type MarketsV2InputType = {
  matchId: Scalars['Int'];
  /** Whether to query live markets */
  isLive: Scalars['Boolean'];
  /** Marked odds token */
  oddsToken: Scalars['String'];
  /** Marked token version */
  version: EnumMarkedTokenVersion;
  /** Sport of the match; used to resolve the compliance spread */
  sportType: EnumSportType;
  /** League (tournament) id of the match; used to resolve the compliance spread */
  leagueId: Scalars['Int'];
};

export type MetadataType = {
  /** Pod name or hostname */
  mn: Scalars['String'];
  /** WebSocket connection unique identifier */
  cid: Scalars['String'];
};


/** Subscription payload, include `added` or `updated` odds and `deleted` odds if any */
export type OddsSubscriptionType = {
  updated: Array<OddsType>;
  deleted: Array<Scalars['Int']>;
};

/** Odds information */
export type OddsType = {
  id: Scalars['Int'];
  eventResult?: Maybe<EventResultType>;
  sport: EnumSportType;
  betCondition: Scalars['String'];
  isLive: Scalars['Boolean'];
  /** Whether this odds offer Mix Parlay */
  hasMixParlay: Scalars['Boolean'];
  marketType: EnumMarketType;
  marketId: Scalars['Int'];
  /** **Don't** use in front-end site, we don't want to leak this information to user */
  maxBet: Scalars['Decimal'];
  sortOrder: Scalars['Int'];
  point: Scalars['Decimal'];
  prices?: Maybe<Array<Price>>;
  status: EnumOddsStatus;
  lastModifiedOn: Scalars['Date'];
};

/** Deleted outright tournament information */
export type OutrightTournamentDeletedType = {
  id: Scalars['Int'];
  isLive: Scalars['Boolean'];
};

/** Subscription payload, include `added` or `updated` outright tournaments and `deleted` outright tournaments if any */
export type OutrightTournamentSubscriptionType = {
  updated: Array<OutrightTournamentType>;
  deleted: Array<OutrightTournamentDeletedType>;
};

/** Outright tournament information */
export type OutrightTournamentType = {
  id: Scalars['Int'];
  eventDate: Scalars['Date'];
  isLive: Scalars['Boolean'];
  tournament: TournamentType;
  oddsCount: Scalars['Int'];
};

export type OutrightTournamentsInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /** Used to filter `Live` outright tournaments only, if `null` then will be ignored */
  isLive?: Maybe<Scalars['Boolean']>;
  /** To optionally filter outright tournaments that start with tournament names */
  tournamentNames?: Maybe<Array<Scalars['String']>>;
  /** To optionally filter outright tournaments by tournament ids */
  tournamentIds?: Maybe<Array<Scalars['Int']>>;
};

/** Outright information */
export type OutrightType = {
  id: Scalars['Int'];
  eventCode: Scalars['String'];
  eventDate: Scalars['Date'];
  isLive: Scalars['Boolean'];
  isWalkinOnly: Scalars['Boolean'];
  /** **Don't** use in front-end site, we don't want to leak this information to user */
  maxBet: Scalars['Decimal'];
  price: Scalars['Decimal'];
  team?: Maybe<TeamType>;
  tournament: TournamentType;
};

export type OutrightsInputType = {
  /** The `Sport Type` to filter the events, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport: EnumSportType;
  /**
   * Show outrights that are in defined `Tournament`
   * If not set, show `outrights` in all tournaments
   */
  tournamentId: Scalars['Int'];
  /** Used to filter `Live` outrights only, if `null` then will be ignored */
  isLive?: Maybe<Scalars['Boolean']>;
};

/** Subscription payload, include `added` or `updated` outrights and `deleted` outrights if any */
export type OutrightsSubscriptionType = {
  updated: Array<OutrightType>;
  deleted: Array<Scalars['Int']>;
};

export type PopularEventsInputType = {
  /**
   * The odds category to filter events
   * If `All` then show all events, otherwise `MixParlay` will only show events that having `MixParlay` odds
   * Default is: `All`
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
  group?: Maybe<EnumPopularEventGroup>;
  /** Optionally limit number of results */
  limit?: Maybe<Scalars['Int']>;
};

export type PopularMixParlaysInputType = {
  sportType: EnumSportType;
  limit?: Maybe<Scalars['Int']>;
};

/** Popular Mix Parlays Information */
export type PopularMixParlaysType = {
  ticketKeys: Array<PopularTicketKey>;
};

/** Popular Mp Information */
export type PopularMpType = {
  ticketKeys: Array<PopularTicketKey>;
};

/** PopularTicketKey information */
export type PopularTicketKey = {
  eventId: Scalars['Int'];
  oddsId: Scalars['Int'];
  option: Scalars['String'];
};

export type PresetFilterInputType = {
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  presetFilter?: Maybe<EnumPresetFilterType>;
  /** The date of event */
  date?: Maybe<EnumEventDateFilterType>;
};

/** Price information */
export type Price = {
  price?: Maybe<Scalars['Decimal']>;
  option: Scalars['String'];
  priceStyle: EnumPriceStyle;
};

export type Query = {
  /** Get sports info */
  sportsInfo: Array<SportInfoType>;
  /** Get sport market info */
  sportMarketInfo: Array<SportMarketInfoType>;
  /** Get popular events for sport and preset filter */
  popularEvents: Array<EventType>;
  /** Get all events that have teams as input */
  teamEvents: Array<Maybe<EventType>>;
  /** Get all events by `Sport` & `Market Page` */
  events: Array<EventType>;
  /** Get all events by `Sport` & `Market Page` & `RegionIds` */
  eventsByRegions: Array<EventType>;
  /** Get all events by Country */
  localEvents: Array<Maybe<EventType>>;
  /** Get events that have live streams */
  streamEvents: Array<EventType>;
  /** Get event by `id` */
  event?: Maybe<EventType>;
  /** Get event count information of preset filters */
  eventsCountInfo: Array<EventsCountInfoType>;
  /** Get live score from all providers */
  liveScore?: Maybe<LiveScoreInfoType>;
  /** Get odds by event */
  eventOdds: Array<OddsType>;
  /** Get markets by match ID and live status */
  markets: Array<MarketType>;
  /** Get markets by match ID and live status, priced with the marked odds token */
  marketsV2: Array<MarketType>;
  /** Get all outright tournaments of sport */
  outrightTournaments: Array<OutrightTournamentType>;
  /** Get outrights based on `sport` & `tournament` */
  outrights: Array<OutrightType>;
  /** Get popular mps */
  popularMps: Array<PopularMpType>;
  /** Get popular mix parlays based on `sport` */
  popularMixParlays: Array<PopularMixParlaysType>;
  /** Get whats hot event ids and odds ids */
  whatsHot: Array<WhatsHotInfoType>;
  /** Get Events by list of event ids */
  eventList: Array<EventType>;
  /** Get tournaments */
  tournaments: Array<TournamentType>;
  /** Get tournaments by size */
  tournamentsBySize: Array<TournamentType>;
  /** Get current tournaments */
  currentTournaments: Array<TournamentType>;
  /** Get tournament groups */
  tournamentGroups: Array<GroupType>;
  /** Get tournament knockout */
  tournamentKnockout: Array<KnockoutType>;
  /** Get topic by name and query */
  topic: TopicType;
  /** Get bet builder event */
  betBuilderEvent?: Maybe<BetBuilderEventType>;
  /** Get bet builder event exists */
  betBuilderEventExists: Scalars['Boolean'];
};


export type QuerysportsInfoArgs = {
  query: SportsInfoInputType;
};


export type QuerysportMarketInfoArgs = {
  query: SportMarketInfoInputType;
};


export type QuerypopularEventsArgs = {
  query: PopularEventsInputType;
};


export type QueryteamEventsArgs = {
  query: TeamEventsInputType;
};


export type QueryeventsArgs = {
  query: EventsInputType;
};


export type QueryeventsByRegionsArgs = {
  query: EventsByRegionsInputType;
};


export type QuerylocalEventsArgs = {
  query: LocalEventsInputType;
};


export type QueryeventArgs = {
  query: EventInputType;
};


export type QueryeventsCountInfoArgs = {
  query: EventsCountInputType;
};


export type QueryliveScoreArgs = {
  query: LiveScoreInputType;
};


export type QueryeventOddsArgs = {
  query: EventOddsInputType;
};


export type QuerymarketsArgs = {
  query: MarketsInputType;
};


export type QuerymarketsV2Args = {
  query: MarketsV2InputType;
};


export type QueryoutrightTournamentsArgs = {
  query: OutrightTournamentsInputType;
};


export type QueryoutrightsArgs = {
  query: OutrightsInputType;
};


export type QuerypopularMixParlaysArgs = {
  query: PopularMixParlaysInputType;
};


export type QuerywhatsHotArgs = {
  query: WhatsHotInputType;
};


export type QueryeventListArgs = {
  query: EventListInputType;
};


export type QuerytournamentsArgs = {
  query: TournamentsInputType;
};


export type QuerytournamentsBySizeArgs = {
  query: TournamentsBySizeInputType;
};


export type QuerycurrentTournamentsArgs = {
  query: SportInputType;
};


export type QuerytournamentGroupsArgs = {
  query: TournamentGroupsInputType;
};


export type QuerytournamentKnockoutArgs = {
  query: TournamentKnockoutInputType;
};


export type QuerytopicArgs = {
  query: TopicRequestInput;
};


export type QuerybetBuilderEventArgs = {
  query: BetBuilderEventInputType;
};


export type QuerybetBuilderEventExistsArgs = {
  query: BetBuilderEventExistsInputType;
};

/** Region information */
export type RegionType = {
  id: Scalars['Int'];
  countryCode: Scalars['String'];
  isCountry?: Maybe<Scalars['Boolean']>;
  /** Dictionary of language to region name */
  regionName: Array<TranslationType>;
};

/** Live score information for SBO */
export type SboLiveScoreType = {
  eventId: Scalars['Int'];
  homeScore: Scalars['Int'];
  awayScore: Scalars['Int'];
};

/** SBO match information */
export type SboMatchType = {
  id?: Maybe<Scalars['Int']>;
  mainMatchResultId?: Maybe<Scalars['Int']>;
  homeTeam?: Maybe<TeamType>;
  awayTeam?: Maybe<TeamType>;
  finalScore?: Maybe<ScoreType>;
  status: TiEnumEventStatus;
};

/** Score information */
export type ScoreType = {
  home?: Maybe<Scalars['Int']>;
  away?: Maybe<Scalars['Int']>;
};

/** Live score information for basketBall */
export type SdtLiveScoreType = {
  homeScore: Scalars['Int'];
  awayScore: Scalars['Int'];
  status: Scalars['Int'];
};


export type SelectionInputType = {
  marketId: Scalars['Int'];
  selectionId: Scalars['Int'];
};

/** Selection (betting option) within a market */
export type SelectionType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  marketId: Scalars['Int'];
  matchId: Scalars['Int'];
  isSuspended: Scalars['Boolean'];
  selectionTypeId: Scalars['Int'];
  selectionOrder: Scalars['Int'];
  template: TemplateType;
  price: MarketPrice;
  market?: Maybe<MarketType>;
};

/** Selection subscription with marked odds token. Only marked token versions are accepted. */
export type SelectionV2InputType = {
  marketId: Scalars['Int'];
  selectionId: Scalars['Int'];
  /** Marked odds token */
  oddsToken: Scalars['String'];
  /** Marked token version */
  version: EnumMarkedTokenVersion;
  /** Sport of the match; used to resolve the compliance spread */
  sportType: EnumSportType;
  /** League (tournament) id of the match; used to resolve the compliance spread */
  leagueId: Scalars['Int'];
};

/** Sport general information */
export type SportInfoType = {
  sport: EnumSportType;
  /** Total count of events include live and non-live */
  eventCount: Scalars['Int'];
  liveEventCount: Scalars['Int'];
  /** Total count of mix parlay events include live and non-live */
  mixParlayEventCount: Scalars['Int'];
  liveMixParlayEventCount: Scalars['Int'];
  /** Total count of outright tournaments include live and non-live */
  outrightTournamentCount: Scalars['Int'];
  liveOutrightTournamentCount: Scalars['Int'];
  simulationEventCount: Scalars['Int'];
  liveSimulationEventCount: Scalars['Int'];
  mixParlaySimulationEventCount: Scalars['Int'];
  liveMixParlaySimulationEventCount: Scalars['Int'];
  filterEFootballEventCount: Scalars['Int'];
  liveFilterEFootballEventCount: Scalars['Int'];
  mixParlayFilterEFootballEventCount: Scalars['Int'];
  liveMixParlayFilterEFootballEventCount: Scalars['Int'];
};

export type SportInputType = {
  sport: EnumSportType;
};

export type SportMarketInfoInputType = {
  timeZone?: Maybe<EnumTimeZoneType>;
  /** To optionally filter sport market info, could be: `Soccer`, `Tennis`, `Basketball`, etc */
  sport?: Maybe<EnumSportType>;
  /** To optionally filter sport market info by preset filter. could be multiple presetFilter like [`All`, `Live`, `NonLive`,.. etc], if not specified, default to [`Live, NonLive, MixParlay, Outright`] */
  presetFilters?: Maybe<Array<Maybe<EnumPresetFilterType>>>;
};

export type SportMarketInfoQueryFilterType = {
  /** The preset filter to display events, could be: `All`, `Live`, `NonLive`, `MixParlay`, etc */
  presetFilter: EnumPresetFilterType;
  /** The date of event */
  date: EnumEventDateFilterType;
};

/** Markets count information */
export type SportMarketInfoType = {
  sport: EnumSportType;
  queryFilter: SportMarketInfoQueryFilterType;
  liveEventCount: Scalars['Int'];
  nonLiveEventCount: Scalars['Int'];
  liveSimulationEventCount: Scalars['Int'];
  nonLiveSimulationEventCount: Scalars['Int'];
  liveFilterEFootballEventCount: Scalars['Int'];
  nonLiveFilterEFootballEventCount: Scalars['Int'];
};

/** Sport information */
export type SportType = {
  id: Scalars['Int'];
  /** Dictionary of language to sport name */
  sportName: Array<TranslationType>;
  /** Dictionary of language to sport short name */
  sportShortName: Array<TranslationType>;
  sportType: EnumSportType;
};

export type SportsInfoInputType = {
  sports?: Maybe<Array<EnumSportType>>;
};

/** Aggregated stream information */
export type StreamType = {
  videoUrl?: Maybe<Scalars['String']>;
  betRadar?: Maybe<BetRadarStreamType>;
  gLive?: Maybe<GLiveStreamType>;
  betConstruct?: Maybe<BetConstructStreamType>;
  betGenius?: Maybe<BetGeniusStreamType>;
};

export type Subscription = {
  /** Subscription for server events */
  server: Scalars['String'];
  /** Subscription for service metadata including connection ID */
  metadata: MetadataType;
  /** Subscription for updating events based on `sport`, and `market page` */
  events: EventsSubscriptionType;
  /** Subscription for updating events based on `sport`, and `market page and regionIds` */
  eventsByRegions: EventsSubscriptionType;
  /** Subscription for get all events by Country */
  localEvents: EventsSubscriptionType;
  /** Subscription for event by `event ID` */
  event?: Maybe<EventType>;
  /** Subscription for live score from all providers */
  liveScore?: Maybe<LiveScoreInfoType>;
  /** Subscription for event odds by `event ID` */
  eventOdds: OddsSubscriptionType;
  /** Subscription for event by `[event ID, event ID]` */
  eventList: EventsSubscriptionType;
  /** Get all outright tournaments of sport */
  outrightTournaments: OutrightTournamentSubscriptionType;
  /** Subscription for outrights by `sport` & `tournament` */
  outrights: OutrightsSubscriptionType;
  /** Subscription for bet builder event by `event ID` */
  betBuilderEvent?: Maybe<BetBuilderEventType>;
  /** Subscription for market changes by matchId */
  markets: MarketsSubscriptionType;
  /** Subscription for selection changes by marketId */
  selection?: Maybe<SelectionType>;
  /** Subscription for market changes by matchId, priced with the marked odds token */
  marketsV2: MarketsSubscriptionType;
  /** Subscription for selection changes by marketId, priced with the marked odds token */
  selectionV2?: Maybe<SelectionType>;
  /** Subscription for dynamic market count changes by matchId */
  dynamicMarketCount: Scalars['Int'];
};


export type SubscriptioneventsArgs = {
  query: EventsInputType;
};


export type SubscriptioneventsByRegionsArgs = {
  query: EventsByRegionsInputType;
};


export type SubscriptionlocalEventsArgs = {
  query: LocalEventsInputType;
};


export type SubscriptioneventArgs = {
  query: EventInputType;
};


export type SubscriptionliveScoreArgs = {
  query: LiveScoreInputType;
};


export type SubscriptioneventOddsArgs = {
  query: EventOddsInputType;
};


export type SubscriptioneventListArgs = {
  query: EventListInputType;
};


export type SubscriptionoutrightTournamentsArgs = {
  query: OutrightTournamentsInputType;
};


export type SubscriptionoutrightsArgs = {
  query: OutrightsInputType;
};


export type SubscriptionbetBuilderEventArgs = {
  query: BetBuilderEventInputType;
};


export type SubscriptionmarketsArgs = {
  query: MarketsInputType;
};


export type SubscriptionselectionArgs = {
  query: SelectionInputType;
};


export type SubscriptionmarketsV2Args = {
  query: MarketsV2InputType;
};


export type SubscriptionselectionV2Args = {
  query: SelectionV2InputType;
};


export type SubscriptiondynamicMarketCountArgs = {
  query: MarketsInputType;
};

/** TeamEventListInputType information */
export type TeamEventsInputType = {
  /** List of team ids */
  ids: Array<Scalars['Int']>;
  /**
   * To set `marketTypeCount` for `All` or `MixParlay` odds count.
   * Default is: `All`.
   */
  oddsCategory?: Maybe<EnumOddsCategoryType>;
};

/** Team information */
export type TeamType = {
  id: Scalars['Int'];
  /** Dictionary of language to team names */
  teamName: Array<TranslationType>;
  countryName?: Maybe<Scalars['String']>;
  teamType: EnumTeamType;
};

/** A single placeholder substitution detail within a template */
export type TemplateDetailType = {
  placeholder?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  translation?: Maybe<ContentTranslationType>;
};

/** Raw template for client-side name resolution */
export type TemplateType = {
  value: Scalars['String'];
  translation?: Maybe<ContentTranslationType>;
  details: Array<TemplateDetailType>;
};

/** Live score information from third party */
export type ThirdPartyLiveScoreType = {
  gameHomeScore?: Maybe<Scalars['Int']>;
  gameAwayScore?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  matchStatus?: Maybe<Scalars['Int']>;
  setHomeScore?: Maybe<Scalars['Int']>;
  setAwayScore?: Maybe<Scalars['Int']>;
  totalHomeScore?: Maybe<Scalars['Int']>;
  totalAwayScore?: Maybe<Scalars['Int']>;
  inPlayPeriod?: Maybe<Scalars['String']>;
};

/** Event status enumeration */
export const enum TiEnumEventStatus {
  Unknown = 'Unknown',
  Running = 'Running',
  Internal = 'Internal',
  Closed = 'Closed',
  Completed = 'Completed'
};

/** Input type for requesting a topic */
export type TopicRequestInput = {
  /** Name of the topic */
  name: Scalars['String'];
  /** Optional query data */
  query?: Maybe<Scalars['JSON']>;
};

/** Topic information returned from a topic request */
export type TopicType = {
  /** The generated topic string */
  topic: Scalars['String'];
};

export type TournamentGroupsInputType = {
  /** The league id to filter tournament groups */
  leagueId: Scalars['Int'];
};

export type TournamentKnockoutInputType = {
  /** The tournament id to filter tournament knockout */
  leagueId: Scalars['Int'];
};

/** Tournament information */
export type TournamentType = {
  id: Scalars['Int'];
  isOlympicSpecialTournament: Scalars['Boolean'];
  isSpecialTournament: Scalars['Boolean'];
  isTestOnly: Scalars['Boolean'];
  region?: Maybe<RegionType>;
  sport?: Maybe<SportType>;
  tournamentCode: Scalars['String'];
  /** Dictionary of language to tournament information */
  tournamentInfo: Array<TranslationType>;
  /** Dictionary of language to tournament names */
  tournamentName: Array<TranslationType>;
  tournamentSize: EnumTournamentSizeType;
  eventsCount: Scalars['Int'];
  isSimulation: Scalars['Boolean'];
  liveEventsCount: Scalars['Int'];
};

export type TournamentsBySizeInputType = {
  sport: EnumSportType;
  sizes: Array<EnumTournamentSizeType>;
};

export type TournamentsInputType = {
  ids: Array<Scalars['Int']>;
  /** The time zone is used for filtering events based on time zone */
  timeZone?: Maybe<EnumTimeZoneType>;
};

/** Translation information */
export type TranslationType = {
  language: EnumLanguageType;
  value: Scalars['String'];
};

export type TvChannelType = {
  countryCode: Scalars['String'];
  channelName: Scalars['String'];
};

export type WhatsHotInfoType = {
  eventId: Scalars['Int'];
  oddsId: Scalars['Int'];
};

export type WhatsHotInputType = {
  type: EnumWhatsHotType;
  /** Only has value when type equals SportType */
  sport?: Maybe<EnumSportType>;
};

export type EventLiveScoresQueryVariables = Exact<{
  query: EventListInputType;
  ids?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type EventLiveScoresQuery = { eventList: Array<(
    Pick<EventType, 'id'>
    & { mainMarketEventResult: (
      Pick<EventResultType, 'id' | 'liveAwayScore' | 'liveHomeScore'>
      & { extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'period' | 'periodStartTime'>> }
    ), eventResults: Array<(
      Pick<EventResultType, 'id' | 'liveAwayScore' | 'liveHomeScore'>
      & { marketGroup?: Maybe<Pick<MarketGroupType, 'id'>> }
    )> }
  )> };

export type EventsCountInfoQueryVariables = Exact<{
  query: EventsCountInputType;
}>;


export type EventsCountInfoQuery = { eventsCountInfo: Array<(
    Pick<EventsCountInfoType, 'eventCount' | 'liveEventCount' | 'simulationEventCount' | 'liveSimulationEventCount' | 'filterEFootballEventCount' | 'liveFilterEFootballEventCount'>
    & { queryFilter: Pick<EventsCountInfoQueryFilterType, 'presetFilter' | 'date'> }
  )> };

export type LiveScoreQueryVariables = Exact<{
  query: LiveScoreInputType;
}>;


export type LiveScoreQuery = { liveScore?: Maybe<(
    Pick<LiveScoreInfoType, 'publishTime'>
    & { sbo?: Maybe<SboLiveScoreTypeFragment>, sdt?: Maybe<SdtLiveScoreTypeFragment>, betRadar?: Maybe<BetRadarLiveScoreTypeFragment>, betConstruct?: Maybe<ThirdPartyLiveScoreTypeFragment>, cricket?: Maybe<CricketLiveScoreTypeFragment>, betGenius?: Maybe<ThirdPartyLiveScoreTypeFragment> }
  )> };

export type LiveScoreSubscriptionVariables = Exact<{
  query: LiveScoreInputType;
}>;


export type LiveScoreSubscription = { liveScore?: Maybe<(
    Pick<LiveScoreInfoType, 'publishTime'>
    & { sbo?: Maybe<SboLiveScoreTypeFragment>, sdt?: Maybe<SdtLiveScoreTypeFragment>, betRadar?: Maybe<BetRadarLiveScoreTypeFragment>, betConstruct?: Maybe<ThirdPartyLiveScoreTypeFragment>, cricket?: Maybe<CricketLiveScoreTypeFragment>, betGenius?: Maybe<ThirdPartyLiveScoreTypeFragment> }
  )> };

export type MetadataSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MetadataSubscription = { metadata: Pick<MetadataType, 'mn' | 'cid'> };

export type SportMarketInfoQueryVariables = Exact<{
  query: SportMarketInfoInputType;
}>;


export type SportMarketInfoQuery = { sportMarketInfo: Array<(
    Pick<SportMarketInfoType, 'sport' | 'liveEventCount' | 'nonLiveEventCount' | 'liveSimulationEventCount' | 'nonLiveSimulationEventCount' | 'liveFilterEFootballEventCount' | 'nonLiveFilterEFootballEventCount'>
    & { queryFilter: Pick<SportMarketInfoQueryFilterType, 'presetFilter' | 'date'> }
  )> };

export type StreamEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type StreamEventsQuery = { streamEvents: Array<(
    Pick<EventType, 'id' | 'eventCode' | 'showTime' | 'showTimeType' | 'isLive' | 'realKickoffTime' | 'homeJersey' | 'awayJersey' | 'isSimulation'>
    & { mainMarketEventResult: (
      Pick<EventResultType, 'sport' | 'liveHomeScore' | 'liveAwayScore' | 'liveHandicapType' | 'nonLiveHandicapType'>
      & { extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'awayRedCards' | 'homeRedCards' | 'injuryTime' | 'period' | 'round' | 'periodStartTime'>> }
    ), awayTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, homeTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, tournament: (
      Pick<TournamentType, 'id' | 'tournamentSize'>
      & { tournamentName: Array<TranslationFragment>, sport?: Maybe<Pick<SportType, 'sportType'>> }
    ), stream?: Maybe<(
      Pick<StreamType, 'videoUrl'>
      & { betRadar?: Maybe<Pick<BetRadarStreamType, 'streamId' | 'streamStatus' | 'allowedCountries'>>, gLive?: Maybe<Pick<GLiveStreamType, 'isPlaying'>>, betConstruct?: Maybe<Pick<BetConstructStreamType, 'eventId' | 'allowedCountries' | 'isPlaying'>>, betGenius?: Maybe<Pick<BetGeniusStreamType, 'eventId' | 'allowedCountries' | 'isPlaying' | 'providerEventId'>> }
    )> }
  )> };

export type BetBuilderEventQueryVariables = Exact<{
  query: BetBuilderEventInputType;
}>;


export type BetBuilderEventQuery = { betBuilderEvent?: Maybe<BetBuilderEventFragment> };

export type BetBuilderEventSubscriptionVariables = Exact<{
  query: BetBuilderEventInputType;
}>;


export type BetBuilderEventSubscription = { betBuilderEvent?: Maybe<BetBuilderEventFragment> };

export type BetBuilderEventExistsQueryVariables = Exact<{
  query: BetBuilderEventExistsInputType;
}>;


export type BetBuilderEventExistsQuery = Pick<Query, 'betBuilderEventExists'>;

export type EventEuroQueryVariables = Exact<{
  query: EventInputType;
}>;


export type EventEuroQuery = { event?: Maybe<EventTypeEuroFragment> };

export type EventEuroSubscriptionVariables = Exact<{
  query: EventInputType;
}>;


export type EventEuroSubscription = { event?: Maybe<EventTypeEuroFragment> };

export type TicketEventEuroQueryVariables = Exact<{
  query: EventInputType;
}>;


export type TicketEventEuroQuery = { event?: Maybe<EventTypeEuroFragment> };

export type EventResultsQueryVariables = Exact<{
  query: EventsInputType;
}>;


export type EventResultsQuery = { events: Array<OddsDisplayEventResultsTypeFragment> };

export type EventResultsSubscriptionVariables = Exact<{
  query: EventsInputType;
}>;


export type EventResultsSubscription = { events: (
    Pick<EventsSubscriptionType, 'deleted'>
    & { updated: Array<OddsDisplayEventResultsTypeFragment> }
  ) };

export type EventsQueryVariables = Exact<{
  query: EventsInputType;
}>;


export type EventsQuery = { events: Array<EventTypeFragment> };

export type EventsSubscriptionVariables = Exact<{
  query: EventsInputType;
}>;


export type EventsSubscription = { events: (
    Pick<EventsSubscriptionType, 'deleted'>
    & { updated: Array<EventTypeFragment> }
  ) };

export type EventsByRegionsQueryVariables = Exact<{
  query: EventsByRegionsInputType;
}>;


export type EventsByRegionsQuery = { eventsByRegions: Array<EventTypeEuroFragment> };

export type EventsByRegionsSubscriptionVariables = Exact<{
  query: EventsByRegionsInputType;
}>;


export type EventsByRegionsSubscription = { eventsByRegions: (
    Pick<EventsSubscriptionType, 'deleted'>
    & { updated: Array<EventTypeEuroFragment> }
  ) };

export type EventsEuroQueryVariables = Exact<{
  query: EventsInputType;
}>;


export type EventsEuroQuery = { events: Array<EventTypeEuroFragment> };

export type EventsEuroSubscriptionVariables = Exact<{
  query: EventsInputType;
}>;


export type EventsEuroSubscription = { events: (
    Pick<EventsSubscriptionType, 'deleted'>
    & { updated: Array<EventTypeEuroFragment> }
  ) };

export type MpRecommendationEventQueryVariables = Exact<{
  query: EventInputType;
}>;


export type MpRecommendationEventQuery = { event?: Maybe<MpRecommendationEventTypeFragment> };

export type MpRecommendationEventSubscriptionVariables = Exact<{
  query: EventInputType;
}>;


export type MpRecommendationEventSubscription = { event?: Maybe<MpRecommendationEventTypeFragment> };

export type OutrightTournamentsEuroQueryVariables = Exact<{
  query: OutrightTournamentsInputType;
}>;


export type OutrightTournamentsEuroQuery = { outrightTournaments: Array<OutrightTournamentTypeEuroFragment> };

export type OutrightTournamentsEuroSubscriptionVariables = Exact<{
  query: OutrightTournamentsInputType;
}>;


export type OutrightTournamentsEuroSubscription = { outrightTournaments: { updated: Array<OutrightTournamentTypeEuroFragment>, deleted: Array<Pick<OutrightTournamentDeletedType, 'id' | 'isLive'>> } };

export type OutrightTournamentsQueryVariables = Exact<{
  query: OutrightTournamentsInputType;
}>;


export type OutrightTournamentsQuery = { outrightTournaments: Array<OutrightTournamentTypeFragment> };

export type OutrightTournamentsSubscriptionVariables = Exact<{
  query: OutrightTournamentsInputType;
}>;


export type OutrightTournamentsSubscription = { outrightTournaments: { updated: Array<OutrightTournamentTypeFragment>, deleted: Array<Pick<OutrightTournamentDeletedType, 'id' | 'isLive'>> } };

export type SimpleEventsQueryVariables = Exact<{
  query: EventsInputType;
}>;


export type SimpleEventsQuery = { events: Array<Pick<EventType, 'id'>> };

export type TournamentEventsQueryVariables = Exact<{
  query: EventsInputType;
}>;


export type TournamentEventsQuery = { events: Array<TournamentEventTypeFragment> };

export type TournamentEventsSubscriptionVariables = Exact<{
  query: EventsInputType;
}>;


export type TournamentEventsSubscription = { events: (
    Pick<EventsSubscriptionType, 'deleted'>
    & { updated: Array<TournamentEventTypeFragment> }
  ) };

export type BetBuilderEventFragment = (
  Pick<BetBuilderEventType, 'matchId'>
  & { markets: Array<BetBuilderMarketFragment> }
);

export type BetBuilderMarketFragment = (
  Pick<BetBuilderMarketType, 'matchMarketId' | 'displayType' | 'point' | 'displayPriority'>
  & { marketType: Pick<BetBuilderMarketTypeType, 'id' | 'name'>, matchStatType: Pick<BetBuilderMatchStatType, 'id' | 'name'>, selections: Array<BetBuilderSelectionFragment> }
);

export type BetBuilderSelectionFragment = (
  Pick<BetBuilderSelectionType, 'id' | 'status'>
  & { selectionType: Pick<BetBuilderSelectionTypeType, 'id' | 'name'> }
);

export type BetRadarLiveScoreTypeFragment = Pick<BetRadarLiveScoreType, 'gameHomeScore' | 'gameAwayScore' | 'setHomeScore' | 'setAwayScore' | 'totalHomeScore' | 'totalAwayScore' | 'inPlayInning' | 'inPlayPeriod' | 'matchStatus' | 'status'>;

export type CricketLiveScoreTypeFragment = Pick<CricketLiveScoreType, 'homeScore' | 'awayScore' | 'homeDismissals' | 'awayDismissals' | 'innings' | 'over' | 'delivery'>;

export type CurrentTournamentsFragment = (
  Pick<TournamentType, 'id' | 'tournamentSize' | 'isSimulation'>
  & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment>, region?: Maybe<(
    Pick<RegionType, 'id'>
    & { regionName: Array<TranslationFragment> }
  )>, sport?: Maybe<Pick<SportType, 'sportType'>> }
);

export type OddsDisplayEventResultsTypeFragment = (
  Pick<EventType, 'id' | 'isSimulation'>
  & { tournament: (
    Pick<TournamentType, 'id'>
    & { sport?: Maybe<Pick<SportType, 'sportType'>> }
  ), eventResults: Array<EventResultTypeFragment> }
);

export type EventResultTypeFragment = (
  Pick<EventResultType, 'id' | 'liveHomeScore' | 'liveAwayScore'>
  & { marketGroup?: Maybe<(
    Pick<MarketGroupType, 'id' | 'displayPriority'>
    & { marketGroupName: Array<TranslationFragment> }
  )>, extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'awayRedCards' | 'homeRedCards'>> }
);

export type EventTypeEuroFragment = (
  Pick<EventType, 'id' | 'eventCode' | 'hasStatistics' | 'liveCourtMatchId' | 'showTime' | 'showTimeType' | 'marketTypeCount' | 'isLive' | 'isSimulation' | 'realKickoffTime' | 'homeJersey' | 'awayJersey' | 'absKickoffTime'>
  & { mainMarketEventResult: (
    Pick<EventResultType, 'liveAwayScore' | 'liveHomeScore' | 'liveHandicapType' | 'nonLiveHandicapType'>
    & { extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'awayRedCards' | 'homeRedCards' | 'injuryTime' | 'period' | 'periodStartTime'>> }
  ), awayTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, homeTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, tournament: (
    Pick<TournamentType, 'id' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment>, sport?: Maybe<Pick<SportType, 'sportType'>>, region?: Maybe<(
      Pick<RegionType, 'id'>
      & { regionName: Array<TranslationFragment> }
    )> }
  ), stream?: Maybe<(
    Pick<StreamType, 'videoUrl'>
    & { betRadar?: Maybe<Pick<BetRadarStreamType, 'streamId' | 'streamStatus' | 'allowedCountries'>>, gLive?: Maybe<Pick<GLiveStreamType, 'isPlaying'>>, betConstruct?: Maybe<Pick<BetConstructStreamType, 'eventId' | 'allowedCountries' | 'isPlaying'>>, betGenius?: Maybe<Pick<BetGeniusStreamType, 'eventId' | 'allowedCountries' | 'isPlaying' | 'providerEventId'>> }
  )> }
);

export type EventTypeFragment = (
  Pick<EventType, 'id' | 'eventCode' | 'eventDate' | 'hasStatistics' | 'liveCourtMatchId' | 'showTime' | 'showTimeType' | 'marketTypeCount' | 'dynamicMarketCount' | 'isLive' | 'isSimulation' | 'realKickoffTime' | 'nonLiveOutrightIds' | 'absKickoffTime'>
  & { tvChannels: Array<Pick<TvChannelType, 'countryCode' | 'channelName'>>, mainMarketEventResult: (
    Pick<EventResultType, 'liveHandicapType' | 'nonLiveHandicapType' | 'isMixParlay'>
    & { extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'injuryTime' | 'period' | 'round' | 'statisticsUrl' | 'periodStartTime'>> }
  ), awayTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, homeTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, tournament: (
    Pick<TournamentType, 'id' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment>, sport?: Maybe<Pick<SportType, 'sportType'>> }
  ), stream?: Maybe<(
    Pick<StreamType, 'videoUrl'>
    & { betRadar?: Maybe<Pick<BetRadarStreamType, 'streamId' | 'streamStatus' | 'allowedCountries'>>, gLive?: Maybe<Pick<GLiveStreamType, 'isPlaying'>>, betConstruct?: Maybe<Pick<BetConstructStreamType, 'eventId' | 'allowedCountries' | 'isPlaying'>>, betGenius?: Maybe<Pick<BetGeniusStreamType, 'eventId' | 'allowedCountries' | 'isPlaying' | 'providerEventId'>> }
  )> }
);

export type MarketTypeFragment = (
  Pick<MarketType, 'id' | 'matchId' | 'marketTypeId' | 'isLive' | 'isSingle' | 'isSuspended' | 'isMixParlayAvailable' | 'matchStatTypeId' | 'displayPriority'>
  & { template: (
    Pick<TemplateType, 'value'>
    & { details: Array<Pick<TemplateDetailType, 'placeholder' | 'value'>> }
  ), selections: Array<(
    Pick<SelectionType, 'id' | 'marketId' | 'matchId' | 'isSuspended' | 'selectionTypeId' | 'selectionOrder'>
    & { template: (
      Pick<TemplateType, 'value'>
      & { details: Array<Pick<TemplateDetailType, 'placeholder' | 'value'>> }
    ), price: Pick<MarketPrice, 'value' | 'oddsStyle'> }
  )> }
);

export type MpRecommendationEventTypeFragment = (
  Pick<EventType, 'id' | 'isSimulation' | 'isLive'>
  & { mainMarketEventResult: (
    Pick<EventResultType, 'id' | 'liveHomeScore' | 'liveAwayScore'>
    & { marketGroup?: Maybe<(
      Pick<MarketGroupType, 'id' | 'displayPriority'>
      & { marketGroupName: Array<TranslationFragment> }
    )> }
  ), awayTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, homeTeam?: Maybe<{ teamName: Array<TranslationFragment> }>, tournament: (
    Pick<TournamentType, 'id' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, sport?: Maybe<Pick<SportType, 'sportType'>> }
  ) }
);

export type OddsTypeFragment = (
  Pick<OddsType, 'id' | 'isLive' | 'hasMixParlay' | 'point' | 'sport' | 'status' | 'betCondition' | 'sortOrder' | 'marketType'>
  & { prices?: Maybe<Array<Pick<Price, 'price' | 'option'>>>, eventResult?: Maybe<(
    Pick<EventResultType, 'id' | 'eventId' | 'liveHomeScore' | 'liveAwayScore' | 'liveHandicapType' | 'nonLiveHandicapType'>
    & { marketGroup?: Maybe<(
      Pick<MarketGroupType, 'id' | 'homeTemplate' | 'awayTemplate' | 'displayPriority' | 'isSingle' | 'isYesNo'>
      & { marketGroupName: Array<TranslationFragment>, homeExtension: Array<TranslationFragment>, awayExtension: Array<TranslationFragment> }
    )> }
  )> }
);

export type OutrightTournamentTypeEuroFragment = (
  Pick<OutrightTournamentType, 'eventDate' | 'isLive' | 'oddsCount'>
  & { tournament: (
    Pick<TournamentType, 'id' | 'tournamentCode' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment> }
  ) }
);

export type OutrightTournamentTypeFragment = (
  Pick<OutrightTournamentType, 'eventDate' | 'oddsCount'>
  & { tournament: (
    Pick<TournamentType, 'id' | 'tournamentCode' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment> }
  ) }
);

export type OutrightTypeFragment = (
  Pick<OutrightType, 'id' | 'eventCode' | 'eventDate' | 'isLive' | 'isWalkinOnly' | 'price'>
  & { team?: Maybe<(
    Pick<TeamType, 'countryName'>
    & { teamName: Array<TranslationFragment> }
  )> }
);

export type SboLiveScoreTypeFragment = Pick<SboLiveScoreType, 'eventId' | 'homeScore' | 'awayScore'>;

export type SdtLiveScoreTypeFragment = Pick<SdtLiveScoreType, 'homeScore' | 'awayScore' | 'status'>;

export type ThirdPartyLiveScoreTypeFragment = Pick<ThirdPartyLiveScoreType, 'gameHomeScore' | 'gameAwayScore' | 'setHomeScore' | 'setAwayScore' | 'totalHomeScore' | 'totalAwayScore' | 'inPlayPeriod' | 'matchStatus' | 'status'>;

export type TournamentEventTypeFragment = (
  Pick<EventType, 'id' | 'eventCode' | 'eventDate' | 'hasStatistics' | 'hasLiveOdds' | 'liveCourtMatchId' | 'showTime' | 'showTimeType' | 'liveMixParlayOddsCount' | 'marketTypeCount' | 'isLive' | 'realKickoffTime' | 'absKickoffTime' | 'isSimulation'>
  & { mainMarketEventResult: (
    Pick<EventResultType, 'liveAwayScore' | 'liveHandicapType' | 'nonLiveHandicapType' | 'liveHomeScore' | 'isMixParlay'>
    & { extraInfo?: Maybe<Pick<EventResultExtraInfoType, 'awayRedCards' | 'homeRedCards' | 'injuryTime' | 'period' | 'round' | 'statisticsUrl' | 'periodStartTime'>> }
  ), totalCornerScore?: Maybe<Pick<EventResultScoreType, 'liveHomeScore' | 'liveAwayScore'>>, awayTeam?: Maybe<(
    Pick<TeamType, 'id' | 'countryName'>
    & { teamName: Array<TranslationFragment> }
  )>, homeTeam?: Maybe<(
    Pick<TeamType, 'id' | 'countryName'>
    & { teamName: Array<TranslationFragment> }
  )>, tournament: (
    Pick<TournamentType, 'id' | 'tournamentSize'>
    & { tournamentName: Array<TranslationFragment>, tournamentInfo: Array<TranslationFragment>, sport?: Maybe<Pick<SportType, 'sportType'>> }
  ), stream?: Maybe<(
    Pick<StreamType, 'videoUrl'>
    & { betRadar?: Maybe<Pick<BetRadarStreamType, 'streamId' | 'streamStatus' | 'allowedCountries'>>, gLive?: Maybe<Pick<GLiveStreamType, 'isPlaying'>>, betConstruct?: Maybe<Pick<BetConstructStreamType, 'eventId' | 'allowedCountries' | 'isPlaying'>>, betGenius?: Maybe<Pick<BetGeniusStreamType, 'eventId' | 'allowedCountries' | 'isPlaying' | 'providerEventId'>> }
  )> }
);

export type TranslationFragment = Pick<TranslationType, 'language' | 'value'>;

export type DynamicMarketCountSubscriptionVariables = Exact<{
  query: MarketsInputType;
}>;


export type DynamicMarketCountSubscription = Pick<Subscription, 'dynamicMarketCount'>;

export type MarketsQueryVariables = Exact<{
  query: MarketsInputType;
}>;


export type MarketsQuery = { markets: Array<MarketTypeFragment> };

export type MarketsSubscriptionVariables = Exact<{
  query: MarketsInputType;
}>;


export type MarketsSubscription = { markets: (
    Pick<MarketsSubscriptionType, 'deleted'>
    & { updated: Array<MarketTypeFragment> }
  ) };

export type MarketsV2QueryVariables = Exact<{
  query: MarketsV2InputType;
}>;


export type MarketsV2Query = { marketsV2: Array<MarketTypeFragment> };

export type MarketsV2SubscriptionVariables = Exact<{
  query: MarketsV2InputType;
}>;


export type MarketsV2Subscription = { marketsV2: (
    Pick<MarketsSubscriptionType, 'deleted'>
    & { updated: Array<MarketTypeFragment> }
  ) };

export type SelectionSubscriptionVariables = Exact<{
  query: SelectionInputType;
}>;


export type SelectionSubscription = { selection?: Maybe<(
    Pick<SelectionType, 'id' | 'marketId' | 'matchId' | 'isSuspended' | 'selectionTypeId' | 'selectionOrder'>
    & { template: (
      Pick<TemplateType, 'value'>
      & { details: Array<Pick<TemplateDetailType, 'placeholder' | 'value'>> }
    ), price: Pick<MarketPrice, 'value' | 'oddsStyle'>, market?: Maybe<Pick<MarketType, 'id' | 'isSuspended'>> }
  )> };

export type SelectionV2SubscriptionVariables = Exact<{
  query: SelectionV2InputType;
}>;


export type SelectionV2Subscription = { selectionV2?: Maybe<(
    Pick<SelectionType, 'id' | 'marketId' | 'matchId' | 'isSuspended' | 'selectionTypeId' | 'selectionOrder'>
    & { template: (
      Pick<TemplateType, 'value'>
      & { details: Array<Pick<TemplateDetailType, 'placeholder' | 'value'>> }
    ), price: Pick<MarketPrice, 'value' | 'oddsStyle'>, market?: Maybe<Pick<MarketType, 'id' | 'isSuspended'>> }
  )> };

export type OddsQueryVariables = Exact<{
  query: EventOddsInputType;
}>;


export type OddsQuery = { eventOdds: Array<OddsTypeFragment> };

export type OddsSubscriptionVariables = Exact<{
  query: EventOddsInputType;
}>;


export type OddsSubscription = { eventOdds: (
    Pick<OddsSubscriptionType, 'deleted'>
    & { updated: Array<OddsTypeFragment> }
  ) };

export type OutrightsQueryVariables = Exact<{
  query: OutrightsInputType;
}>;


export type OutrightsQuery = { outrights: Array<OutrightTypeFragment> };

export type OutrightsSubscriptionVariables = Exact<{
  query: OutrightsInputType;
}>;


export type OutrightsSubscription = { outrights: (
    Pick<OutrightsSubscriptionType, 'deleted'>
    & { updated: Array<OutrightTypeFragment> }
  ) };

export type CurrentTournamentsQueryVariables = Exact<{
  query: SportInputType;
}>;


export type CurrentTournamentsQuery = { currentTournaments: Array<CurrentTournamentsFragment> };

export type TournamentGroupsQueryVariables = Exact<{
  query: TournamentGroupsInputType;
}>;


export type TournamentGroupsQuery = { tournamentGroups: Array<(
    Pick<GroupType, 'groupName'>
    & { teamList: Array<(
      Pick<GroupTeamType, 'id' | 'countryName' | 'played' | 'won' | 'drawn' | 'lost' | 'goalDifference' | 'points' | 'ranking' | 'isQualified'>
      & { teamName: Array<Pick<TranslationType, 'language' | 'value'>> }
    )> }
  )> };

export type TournamentKnockoutQueryVariables = Exact<{
  query: TournamentKnockoutInputType;
}>;


export type TournamentKnockoutQuery = { tournamentKnockout: Array<KnockoutFragment> };

export type KnockoutFragment = (
  Pick<KnockoutType, 'stage'>
  & { matchList: Array<KnockoutMatchFragment> }
);

export type KnockoutMatchFragment = (
  Pick<KnockoutMatchType, 'datetime' | 'homePlaceHolder' | 'awayPlaceHolder'>
  & { regularMatch?: Maybe<SboMatchFragment>, extraTimeMatch?: Maybe<SboMatchFragment>, penaltyMatch?: Maybe<SboMatchFragment>, homeTeam?: Maybe<KnockoutTeamFragment>, awayTeam?: Maybe<KnockoutTeamFragment> }
);

export type SboMatchFragment = (
  Pick<SboMatchType, 'id' | 'mainMatchResultId' | 'status'>
  & { homeTeam?: Maybe<KnockoutTeamFragment>, awayTeam?: Maybe<KnockoutTeamFragment>, finalScore?: Maybe<Pick<ScoreType, 'home' | 'away'>> }
);

export type KnockoutTeamFragment = (
  Pick<TeamType, 'id' | 'countryName'>
  & { teamName: Array<TranslationFragment> }
);

export const BetBuilderSelectionFragment = gql`
    fragment BetBuilderSelectionFragment on BetBuilderSelectionType {
  id
  status
  selectionType {
    id
    name
  }
}
    `;
export const BetBuilderMarketFragment = gql`
    fragment BetBuilderMarketFragment on BetBuilderMarketType {
  matchMarketId
  marketType {
    id
    name
  }
  matchStatType {
    id
    name
  }
  displayType
  point
  displayPriority
  selections {
    ...BetBuilderSelectionFragment
  }
}
    ${BetBuilderSelectionFragment}`;
export const BetBuilderEventFragment = gql`
    fragment BetBuilderEventFragment on BetBuilderEventType {
  matchId
  markets {
    ...BetBuilderMarketFragment
  }
}
    ${BetBuilderMarketFragment}`;
export const BetRadarLiveScoreTypeFragment = gql`
    fragment BetRadarLiveScoreTypeFragment on BetRadarLiveScoreType {
  gameHomeScore
  gameAwayScore
  setHomeScore
  setAwayScore
  totalHomeScore
  totalAwayScore
  inPlayInning
  inPlayPeriod
  matchStatus
  status
}
    `;
export const CricketLiveScoreTypeFragment = gql`
    fragment CricketLiveScoreTypeFragment on CricketLiveScoreType {
  homeScore
  awayScore
  homeDismissals
  awayDismissals
  innings
  over
  delivery
}
    `;
export const TranslationFragment = gql`
    fragment TranslationFragment on TranslationType {
  language
  value
}
    `;
export const CurrentTournamentsFragment = gql`
    fragment CurrentTournamentsFragment on TournamentType {
  id
  tournamentName {
    ...TranslationFragment
  }
  tournamentInfo {
    ...TranslationFragment
  }
  tournamentSize
  region {
    id
    regionName {
      ...TranslationFragment
    }
  }
  isSimulation
  sport {
    sportType
  }
}
    ${TranslationFragment}`;
export const EventResultTypeFragment = gql`
    fragment EventResultTypeFragment on EventResultType {
  id
  liveHomeScore
  liveAwayScore
  marketGroup {
    id
    marketGroupName {
      ...TranslationFragment
    }
    displayPriority
  }
  extraInfo {
    awayRedCards
    homeRedCards
  }
}
    ${TranslationFragment}`;
export const OddsDisplayEventResultsTypeFragment = gql`
    fragment OddsDisplayEventResultsTypeFragment on EventType {
  id
  tournament {
    id
    sport {
      sportType
    }
  }
  eventResults {
    ...EventResultTypeFragment
  }
  isSimulation
}
    ${EventResultTypeFragment}`;
export const EventTypeEuroFragment = gql`
    fragment EventTypeEuroFragment on EventType {
  id
  eventCode
  hasStatistics
  liveCourtMatchId
  showTime
  showTimeType
  marketTypeCount
  isLive
  isSimulation
  realKickoffTime
  mainMarketEventResult {
    liveAwayScore
    liveHomeScore
    liveHandicapType
    nonLiveHandicapType
    extraInfo {
      awayRedCards
      homeRedCards
      injuryTime
      period
      periodStartTime
    }
  }
  awayTeam {
    teamName {
      ...TranslationFragment
    }
  }
  homeTeam {
    teamName {
      ...TranslationFragment
    }
  }
  homeJersey
  awayJersey
  tournament {
    id
    tournamentName {
      ...TranslationFragment
    }
    tournamentInfo {
      ...TranslationFragment
    }
    tournamentSize
    sport {
      sportType
    }
    region {
      id
      regionName {
        ...TranslationFragment
      }
    }
  }
  stream {
    videoUrl
    betRadar {
      streamId
      streamStatus
      allowedCountries
    }
    gLive {
      isPlaying
    }
    betConstruct {
      eventId
      allowedCountries
      isPlaying
    }
    betGenius {
      eventId
      allowedCountries
      isPlaying
      providerEventId
    }
  }
  absKickoffTime
}
    ${TranslationFragment}`;
export const EventTypeFragment = gql`
    fragment EventTypeFragment on EventType {
  id
  eventCode
  eventDate
  hasStatistics
  liveCourtMatchId
  showTime
  showTimeType
  tvChannels {
    countryCode
    channelName
  }
  marketTypeCount
  dynamicMarketCount
  isLive
  isSimulation
  realKickoffTime
  mainMarketEventResult {
    liveHandicapType
    nonLiveHandicapType
    isMixParlay
    extraInfo {
      injuryTime
      period
      round
      statisticsUrl
      periodStartTime
    }
  }
  awayTeam {
    teamName {
      ...TranslationFragment
    }
  }
  homeTeam {
    teamName {
      ...TranslationFragment
    }
  }
  tournament {
    id
    tournamentName {
      ...TranslationFragment
    }
    tournamentInfo {
      ...TranslationFragment
    }
    tournamentSize
    sport {
      sportType
    }
  }
  stream {
    videoUrl
    betRadar {
      streamId
      streamStatus
      allowedCountries
    }
    gLive {
      isPlaying
    }
    betConstruct {
      eventId
      allowedCountries
      isPlaying
    }
    betGenius {
      eventId
      allowedCountries
      isPlaying
      providerEventId
    }
  }
  nonLiveOutrightIds
  absKickoffTime
}
    ${TranslationFragment}`;
export const MarketTypeFragment = gql`
    fragment MarketTypeFragment on MarketType {
  id
  matchId
  marketTypeId
  isLive
  isSingle
  isSuspended
  isMixParlayAvailable
  matchStatTypeId
  displayPriority
  template {
    value
    details {
      placeholder
      value
    }
  }
  selections {
    id
    marketId
    matchId
    isSuspended
    selectionTypeId
    selectionOrder
    template {
      value
      details {
        placeholder
        value
      }
    }
    price {
      value
      oddsStyle
    }
  }
}
    `;
export const MpRecommendationEventTypeFragment = gql`
    fragment MpRecommendationEventTypeFragment on EventType {
  id
  isSimulation
  mainMarketEventResult {
    id
    liveHomeScore
    liveAwayScore
    marketGroup {
      id
      marketGroupName {
        ...TranslationFragment
      }
      displayPriority
    }
  }
  awayTeam {
    teamName {
      ...TranslationFragment
    }
  }
  homeTeam {
    teamName {
      ...TranslationFragment
    }
  }
  tournament {
    tournamentName {
      ...TranslationFragment
    }
    id
    tournamentSize
    sport {
      sportType
    }
  }
  isLive
}
    ${TranslationFragment}`;
export const OddsTypeFragment = gql`
    fragment OddsTypeFragment on OddsType {
  id
  isLive
  hasMixParlay
  point
  sport
  status
  betCondition
  sortOrder
  marketType
  prices {
    price
    option
  }
  eventResult {
    id
    eventId
    liveHomeScore
    liveAwayScore
    liveHandicapType
    nonLiveHandicapType
    marketGroup {
      id
      marketGroupName {
        ...TranslationFragment
      }
      homeTemplate
      awayTemplate
      homeExtension {
        ...TranslationFragment
      }
      awayExtension {
        ...TranslationFragment
      }
      displayPriority
      isSingle
      isYesNo
    }
  }
}
    ${TranslationFragment}`;
export const OutrightTournamentTypeEuroFragment = gql`
    fragment OutrightTournamentTypeEuroFragment on OutrightTournamentType {
  eventDate
  isLive
  tournament {
    id
    tournamentName {
      ...TranslationFragment
    }
    tournamentInfo {
      ...TranslationFragment
    }
    tournamentCode
    tournamentSize
  }
  oddsCount
}
    ${TranslationFragment}`;
export const OutrightTournamentTypeFragment = gql`
    fragment OutrightTournamentTypeFragment on OutrightTournamentType {
  eventDate
  tournament {
    id
    tournamentName {
      ...TranslationFragment
    }
    tournamentInfo {
      ...TranslationFragment
    }
    tournamentCode
    tournamentSize
  }
  oddsCount
}
    ${TranslationFragment}`;
export const OutrightTypeFragment = gql`
    fragment OutrightTypeFragment on OutrightType {
  id
  eventCode
  eventDate
  isLive
  isWalkinOnly
  price
  team {
    teamName {
      ...TranslationFragment
    }
    countryName
  }
}
    ${TranslationFragment}`;
export const SboLiveScoreTypeFragment = gql`
    fragment SboLiveScoreTypeFragment on SboLiveScoreType {
  eventId
  homeScore
  awayScore
}
    `;
export const SdtLiveScoreTypeFragment = gql`
    fragment SdtLiveScoreTypeFragment on SdtLiveScoreType {
  homeScore
  awayScore
  status
}
    `;
export const ThirdPartyLiveScoreTypeFragment = gql`
    fragment ThirdPartyLiveScoreTypeFragment on ThirdPartyLiveScoreType {
  gameHomeScore
  gameAwayScore
  setHomeScore
  setAwayScore
  totalHomeScore
  totalAwayScore
  inPlayPeriod
  matchStatus
  status
}
    `;
export const TournamentEventTypeFragment = gql`
    fragment TournamentEventTypeFragment on EventType {
  id
  eventCode
  eventDate
  hasStatistics
  hasLiveOdds
  liveCourtMatchId
  showTime
  showTimeType
  liveMixParlayOddsCount
  marketTypeCount
  isLive
  realKickoffTime
  absKickoffTime
  mainMarketEventResult {
    liveAwayScore
    liveHandicapType
    nonLiveHandicapType
    liveHomeScore
    isMixParlay
    extraInfo {
      awayRedCards
      homeRedCards
      injuryTime
      period
      round
      statisticsUrl
      periodStartTime
    }
  }
  totalCornerScore {
    liveHomeScore
    liveAwayScore
  }
  awayTeam {
    id
    countryName
    teamName {
      ...TranslationFragment
    }
  }
  homeTeam {
    id
    countryName
    teamName {
      ...TranslationFragment
    }
  }
  tournament {
    id
    tournamentName {
      ...TranslationFragment
    }
    tournamentInfo {
      ...TranslationFragment
    }
    tournamentSize
    sport {
      sportType
    }
  }
  stream {
    videoUrl
    betRadar {
      streamId
      streamStatus
      allowedCountries
    }
    gLive {
      isPlaying
    }
    betConstruct {
      eventId
      allowedCountries
      isPlaying
    }
    betGenius {
      eventId
      allowedCountries
      isPlaying
      providerEventId
    }
  }
  isSimulation
}
    ${TranslationFragment}`;
export const KnockoutTeamFragment = gql`
    fragment KnockoutTeamFragment on TeamType {
  id
  teamName {
    ...TranslationFragment
  }
  countryName
}
    ${TranslationFragment}`;
export const SboMatchFragment = gql`
    fragment SboMatchFragment on SboMatchType {
  id
  mainMatchResultId
  homeTeam {
    ...KnockoutTeamFragment
  }
  awayTeam {
    ...KnockoutTeamFragment
  }
  finalScore {
    home
    away
  }
  status
}
    ${KnockoutTeamFragment}`;
export const KnockoutMatchFragment = gql`
    fragment KnockoutMatchFragment on KnockoutMatchType {
  datetime
  homePlaceHolder
  awayPlaceHolder
  regularMatch {
    ...SboMatchFragment
  }
  extraTimeMatch {
    ...SboMatchFragment
  }
  penaltyMatch {
    ...SboMatchFragment
  }
  homeTeam {
    ...KnockoutTeamFragment
  }
  awayTeam {
    ...KnockoutTeamFragment
  }
}
    ${SboMatchFragment}
${KnockoutTeamFragment}`;
export const KnockoutFragment = gql`
    fragment KnockoutFragment on KnockoutType {
  stage
  matchList {
    ...KnockoutMatchFragment
  }
}
    ${KnockoutMatchFragment}`;
export const EventLiveScoresQueryDocument = gql`
    query EventLiveScoresQuery($query: EventListInputType!, $ids: [Int!]) {
  eventList(query: $query) {
    id
    mainMarketEventResult {
      id
      liveAwayScore
      liveHomeScore
      extraInfo {
        period
        periodStartTime
      }
    }
    eventResults(ids: $ids) {
      id
      liveAwayScore
      liveHomeScore
      marketGroup {
        id
      }
    }
  }
}
    `;

/**
 * __useEventLiveScoresQuery__
 *
 * To run a query within a Vue component, call `useEventLiveScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLiveScoresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventLiveScoresQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 * });
 */
export const useEventLiveScoresQuery = useApolloQuery<EventLiveScoresQuery, EventLiveScoresQueryVariables>(EventLiveScoresQueryDocument, { clientId: 'oddsApi' });
export const EventsCountInfoQueryDocument = gql`
    query EventsCountInfoQuery($query: EventsCountInputType!) {
  eventsCountInfo(query: $query) {
    eventCount
    liveEventCount
    simulationEventCount
    liveSimulationEventCount
    filterEFootballEventCount
    liveFilterEFootballEventCount
    queryFilter {
      presetFilter
      date
    }
  }
}
    `;

/**
 * __useEventsCountInfoQuery__
 *
 * To run a query within a Vue component, call `useEventsCountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsCountInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsCountInfoQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventsCountInfoQuery = useApolloQuery<EventsCountInfoQuery, EventsCountInfoQueryVariables>(EventsCountInfoQueryDocument, { clientId: 'oddsApi' });
export const LiveScoreQueryDocument = gql`
    query LiveScoreQuery($query: LiveScoreInputType!) {
  liveScore(query: $query) {
    sbo {
      ...SboLiveScoreTypeFragment
    }
    sdt {
      ...SdtLiveScoreTypeFragment
    }
    betRadar {
      ...BetRadarLiveScoreTypeFragment
    }
    betConstruct {
      ...ThirdPartyLiveScoreTypeFragment
    }
    cricket {
      ...CricketLiveScoreTypeFragment
    }
    betGenius {
      ...ThirdPartyLiveScoreTypeFragment
    }
    publishTime
  }
}
    ${SboLiveScoreTypeFragment}
${SdtLiveScoreTypeFragment}
${BetRadarLiveScoreTypeFragment}
${ThirdPartyLiveScoreTypeFragment}
${CricketLiveScoreTypeFragment}`;

/**
 * __useLiveScoreQuery__
 *
 * To run a query within a Vue component, call `useLiveScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveScoreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLiveScoreQuery({
 *   query: // value for 'query'
 * });
 */
export const useLiveScoreQuery = useApolloQuery<LiveScoreQuery, LiveScoreQueryVariables>(LiveScoreQueryDocument, { clientId: 'oddsApi' });
export const LiveScoreSubscriptionDocument = gql`
    subscription LiveScoreSubscription($query: LiveScoreInputType!) {
  liveScore(query: $query) {
    sbo {
      ...SboLiveScoreTypeFragment
    }
    sdt {
      ...SdtLiveScoreTypeFragment
    }
    betRadar {
      ...BetRadarLiveScoreTypeFragment
    }
    betConstruct {
      ...ThirdPartyLiveScoreTypeFragment
    }
    cricket {
      ...CricketLiveScoreTypeFragment
    }
    betGenius {
      ...ThirdPartyLiveScoreTypeFragment
    }
    publishTime
  }
}
    ${SboLiveScoreTypeFragment}
${SdtLiveScoreTypeFragment}
${BetRadarLiveScoreTypeFragment}
${ThirdPartyLiveScoreTypeFragment}
${CricketLiveScoreTypeFragment}`;

/**
 * __useLiveScoreSubscription__
 *
 * To run a query within a Vue component, call `useLiveScoreSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveScoreSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useLiveScoreSubscription({
 *   query: // value for 'query'
 * });
 */
export const useLiveScoreSubscription = useApolloSubscription<LiveScoreSubscription, LiveScoreSubscriptionVariables>(LiveScoreSubscriptionDocument, { clientId: 'oddsApi' });
export const MetadataSubscriptionDocument = gql`
    subscription MetadataSubscription {
  metadata {
    mn
    cid
  }
}
    `;

/**
 * __useMetadataSubscription__
 *
 * To run a query within a Vue component, call `useMetadataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMetadataSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMetadataSubscription();
 */
export const useMetadataSubscription = useApolloSubscription<MetadataSubscription, MetadataSubscriptionVariables>(MetadataSubscriptionDocument, true, { clientId: 'oddsApi' });
export const SportMarketInfoQueryDocument = gql`
    query SportMarketInfoQuery($query: SportMarketInfoInputType!) {
  sportMarketInfo(query: $query) {
    sport
    queryFilter {
      presetFilter
      date
    }
    liveEventCount
    nonLiveEventCount
    liveSimulationEventCount
    nonLiveSimulationEventCount
    liveFilterEFootballEventCount
    nonLiveFilterEFootballEventCount
  }
}
    `;

/**
 * __useSportMarketInfoQuery__
 *
 * To run a query within a Vue component, call `useSportMarketInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSportMarketInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSportMarketInfoQuery({
 *   query: // value for 'query'
 * });
 */
export const useSportMarketInfoQuery = useApolloQuery<SportMarketInfoQuery, SportMarketInfoQueryVariables>(SportMarketInfoQueryDocument, { clientId: 'oddsApi' });
export const StreamEventsQueryDocument = gql`
    query StreamEventsQuery {
  streamEvents {
    id
    eventCode
    showTime
    showTimeType
    isLive
    realKickoffTime
    mainMarketEventResult {
      sport
      liveHomeScore
      liveAwayScore
      liveHandicapType
      nonLiveHandicapType
      extraInfo {
        awayRedCards
        homeRedCards
        injuryTime
        period
        round
        periodStartTime
      }
    }
    awayTeam {
      teamName {
        ...TranslationFragment
      }
    }
    homeTeam {
      teamName {
        ...TranslationFragment
      }
    }
    homeJersey
    awayJersey
    tournament {
      id
      tournamentName {
        ...TranslationFragment
      }
      tournamentSize
      sport {
        sportType
      }
    }
    stream {
      videoUrl
      betRadar {
        streamId
        streamStatus
        allowedCountries
      }
      gLive {
        isPlaying
      }
      betConstruct {
        eventId
        allowedCountries
        isPlaying
      }
      betGenius {
        eventId
        allowedCountries
        isPlaying
        providerEventId
      }
    }
    isSimulation
    tournament {
      id
      sport {
        sportType
      }
    }
  }
}
    ${TranslationFragment}`;

/**
 * __useStreamEventsQuery__
 *
 * To run a query within a Vue component, call `useStreamEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStreamEventsQuery();
 */
export const useStreamEventsQuery = useApolloQuery<StreamEventsQuery, StreamEventsQueryVariables>(StreamEventsQueryDocument, true, { clientId: 'oddsApi' });
export const BetBuilderEventQueryDocument = gql`
    query BetBuilderEventQuery($query: BetBuilderEventInputType!) {
  betBuilderEvent(query: $query) {
    ...BetBuilderEventFragment
  }
}
    ${BetBuilderEventFragment}`;

/**
 * __useBetBuilderEventQuery__
 *
 * To run a query within a Vue component, call `useBetBuilderEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useBetBuilderEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBetBuilderEventQuery({
 *   query: // value for 'query'
 * });
 */
export const useBetBuilderEventQuery = useApolloQuery<BetBuilderEventQuery, BetBuilderEventQueryVariables>(BetBuilderEventQueryDocument, { clientId: 'oddsApi' });
export const BetBuilderEventSubscriptionDocument = gql`
    subscription BetBuilderEventSubscription($query: BetBuilderEventInputType!) {
  betBuilderEvent(query: $query) {
    ...BetBuilderEventFragment
  }
}
    ${BetBuilderEventFragment}`;

/**
 * __useBetBuilderEventSubscription__
 *
 * To run a query within a Vue component, call `useBetBuilderEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBetBuilderEventSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useBetBuilderEventSubscription({
 *   query: // value for 'query'
 * });
 */
export const useBetBuilderEventSubscription = useApolloSubscription<BetBuilderEventSubscription, BetBuilderEventSubscriptionVariables>(BetBuilderEventSubscriptionDocument, { clientId: 'oddsApi' });
export const BetBuilderEventExistsQueryDocument = gql`
    query BetBuilderEventExistsQuery($query: BetBuilderEventExistsInputType!) {
  betBuilderEventExists(query: $query)
}
    `;

/**
 * __useBetBuilderEventExistsQuery__
 *
 * To run a query within a Vue component, call `useBetBuilderEventExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBetBuilderEventExistsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBetBuilderEventExistsQuery({
 *   query: // value for 'query'
 * });
 */
export const useBetBuilderEventExistsQuery = useApolloQuery<BetBuilderEventExistsQuery, BetBuilderEventExistsQueryVariables>(BetBuilderEventExistsQueryDocument, { clientId: 'oddsApi' });
export const EventEuroQueryDocument = gql`
    query EventEuroQuery($query: EventInputType!) {
  event(query: $query) {
    ...EventTypeEuroFragment
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventEuroQuery__
 *
 * To run a query within a Vue component, call `useEventEuroQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventEuroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventEuroQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventEuroQuery = useApolloQuery<EventEuroQuery, EventEuroQueryVariables>(EventEuroQueryDocument, { clientId: 'oddsApi' });
export const EventEuroSubscriptionDocument = gql`
    subscription EventEuroSubscription($query: EventInputType!) {
  event(query: $query) {
    ...EventTypeEuroFragment
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventEuroSubscription__
 *
 * To run a query within a Vue component, call `useEventEuroSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventEuroSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useEventEuroSubscription({
 *   query: // value for 'query'
 * });
 */
export const useEventEuroSubscription = useApolloSubscription<EventEuroSubscription, EventEuroSubscriptionVariables>(EventEuroSubscriptionDocument, { clientId: 'oddsApi' });
export const TicketEventEuroQueryDocument = gql`
    query TicketEventEuroQuery($query: EventInputType!) {
  event(query: $query) {
    ...EventTypeEuroFragment
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useTicketEventEuroQuery__
 *
 * To run a query within a Vue component, call `useTicketEventEuroQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketEventEuroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTicketEventEuroQuery({
 *   query: // value for 'query'
 * });
 */
export const useTicketEventEuroQuery = useApolloQuery<TicketEventEuroQuery, TicketEventEuroQueryVariables>(TicketEventEuroQueryDocument, { clientId: 'oddsApi' });
export const EventResultsQueryDocument = gql`
    query EventResultsQuery($query: EventsInputType!) {
  events(query: $query) {
    ...OddsDisplayEventResultsTypeFragment
  }
}
    ${OddsDisplayEventResultsTypeFragment}`;

/**
 * __useEventResultsQuery__
 *
 * To run a query within a Vue component, call `useEventResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventResultsQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventResultsQuery = useApolloQuery<EventResultsQuery, EventResultsQueryVariables>(EventResultsQueryDocument, { clientId: 'oddsApi' });
export const EventResultsSubscriptionDocument = gql`
    subscription EventResultsSubscription($query: EventsInputType!) {
  events(query: $query) {
    updated {
      ...OddsDisplayEventResultsTypeFragment
    }
    deleted
  }
}
    ${OddsDisplayEventResultsTypeFragment}`;

/**
 * __useEventResultsSubscription__
 *
 * To run a query within a Vue component, call `useEventResultsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventResultsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useEventResultsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useEventResultsSubscription = useApolloSubscription<EventResultsSubscription, EventResultsSubscriptionVariables>(EventResultsSubscriptionDocument, { clientId: 'oddsApi' });
export const EventsQueryDocument = gql`
    query EventsQuery($query: EventsInputType!) {
  events(query: $query) {
    ...EventTypeFragment
  }
}
    ${EventTypeFragment}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a Vue component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventsQuery = useApolloQuery<EventsQuery, EventsQueryVariables>(EventsQueryDocument, { clientId: 'oddsApi' });
export const EventsSubscriptionDocument = gql`
    subscription EventsSubscription($query: EventsInputType!) {
  events(query: $query) {
    updated {
      ...EventTypeFragment
    }
    deleted
  }
}
    ${EventTypeFragment}`;

/**
 * __useEventsSubscription__
 *
 * To run a query within a Vue component, call `useEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useEventsSubscription = useApolloSubscription<EventsSubscription, EventsSubscriptionVariables>(EventsSubscriptionDocument, { clientId: 'oddsApi' });
export const EventsByRegionsQueryDocument = gql`
    query EventsByRegionsQuery($query: EventsByRegionsInputType!) {
  eventsByRegions(query: $query) {
    ...EventTypeEuroFragment
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventsByRegionsQuery__
 *
 * To run a query within a Vue component, call `useEventsByRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsByRegionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsByRegionsQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventsByRegionsQuery = useApolloQuery<EventsByRegionsQuery, EventsByRegionsQueryVariables>(EventsByRegionsQueryDocument, { clientId: 'oddsApi' });
export const EventsByRegionsSubscriptionDocument = gql`
    subscription EventsByRegionsSubscription($query: EventsByRegionsInputType!) {
  eventsByRegions(query: $query) {
    updated {
      ...EventTypeEuroFragment
    }
    deleted
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventsByRegionsSubscription__
 *
 * To run a query within a Vue component, call `useEventsByRegionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventsByRegionsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsByRegionsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useEventsByRegionsSubscription = useApolloSubscription<EventsByRegionsSubscription, EventsByRegionsSubscriptionVariables>(EventsByRegionsSubscriptionDocument, { clientId: 'oddsApi' });
export const EventsEuroQueryDocument = gql`
    query EventsEuroQuery($query: EventsInputType!) {
  events(query: $query) {
    ...EventTypeEuroFragment
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventsEuroQuery__
 *
 * To run a query within a Vue component, call `useEventsEuroQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsEuroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsEuroQuery({
 *   query: // value for 'query'
 * });
 */
export const useEventsEuroQuery = useApolloQuery<EventsEuroQuery, EventsEuroQueryVariables>(EventsEuroQueryDocument, { clientId: 'oddsApi' });
export const EventsEuroSubscriptionDocument = gql`
    subscription EventsEuroSubscription($query: EventsInputType!) {
  events(query: $query) {
    updated {
      ...EventTypeEuroFragment
    }
    deleted
  }
}
    ${EventTypeEuroFragment}`;

/**
 * __useEventsEuroSubscription__
 *
 * To run a query within a Vue component, call `useEventsEuroSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventsEuroSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useEventsEuroSubscription({
 *   query: // value for 'query'
 * });
 */
export const useEventsEuroSubscription = useApolloSubscription<EventsEuroSubscription, EventsEuroSubscriptionVariables>(EventsEuroSubscriptionDocument, { clientId: 'oddsApi' });
export const MpRecommendationEventQueryDocument = gql`
    query MpRecommendationEventQuery($query: EventInputType!) {
  event(query: $query) {
    ...MpRecommendationEventTypeFragment
  }
}
    ${MpRecommendationEventTypeFragment}`;

/**
 * __useMpRecommendationEventQuery__
 *
 * To run a query within a Vue component, call `useMpRecommendationEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useMpRecommendationEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMpRecommendationEventQuery({
 *   query: // value for 'query'
 * });
 */
export const useMpRecommendationEventQuery = useApolloQuery<MpRecommendationEventQuery, MpRecommendationEventQueryVariables>(MpRecommendationEventQueryDocument, { clientId: 'oddsApi' });
export const MpRecommendationEventSubscriptionDocument = gql`
    subscription MpRecommendationEventSubscription($query: EventInputType!) {
  event(query: $query) {
    ...MpRecommendationEventTypeFragment
  }
}
    ${MpRecommendationEventTypeFragment}`;

/**
 * __useMpRecommendationEventSubscription__
 *
 * To run a query within a Vue component, call `useMpRecommendationEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMpRecommendationEventSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMpRecommendationEventSubscription({
 *   query: // value for 'query'
 * });
 */
export const useMpRecommendationEventSubscription = useApolloSubscription<MpRecommendationEventSubscription, MpRecommendationEventSubscriptionVariables>(MpRecommendationEventSubscriptionDocument, { clientId: 'oddsApi' });
export const OutrightTournamentsEuroQueryDocument = gql`
    query OutrightTournamentsEuroQuery($query: OutrightTournamentsInputType!) {
  outrightTournaments(query: $query) {
    ...OutrightTournamentTypeEuroFragment
  }
}
    ${OutrightTournamentTypeEuroFragment}`;

/**
 * __useOutrightTournamentsEuroQuery__
 *
 * To run a query within a Vue component, call `useOutrightTournamentsEuroQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutrightTournamentsEuroQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightTournamentsEuroQuery({
 *   query: // value for 'query'
 * });
 */
export const useOutrightTournamentsEuroQuery = useApolloQuery<OutrightTournamentsEuroQuery, OutrightTournamentsEuroQueryVariables>(OutrightTournamentsEuroQueryDocument, { clientId: 'oddsApi' });
export const OutrightTournamentsEuroSubscriptionDocument = gql`
    subscription OutrightTournamentsEuroSubscription($query: OutrightTournamentsInputType!) {
  outrightTournaments(query: $query) {
    updated {
      ...OutrightTournamentTypeEuroFragment
    }
    deleted {
      id
      isLive
    }
  }
}
    ${OutrightTournamentTypeEuroFragment}`;

/**
 * __useOutrightTournamentsEuroSubscription__
 *
 * To run a query within a Vue component, call `useOutrightTournamentsEuroSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOutrightTournamentsEuroSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightTournamentsEuroSubscription({
 *   query: // value for 'query'
 * });
 */
export const useOutrightTournamentsEuroSubscription = useApolloSubscription<OutrightTournamentsEuroSubscription, OutrightTournamentsEuroSubscriptionVariables>(OutrightTournamentsEuroSubscriptionDocument, { clientId: 'oddsApi' });
export const OutrightTournamentsQueryDocument = gql`
    query OutrightTournamentsQuery($query: OutrightTournamentsInputType!) {
  outrightTournaments(query: $query) {
    ...OutrightTournamentTypeFragment
  }
}
    ${OutrightTournamentTypeFragment}`;

/**
 * __useOutrightTournamentsQuery__
 *
 * To run a query within a Vue component, call `useOutrightTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutrightTournamentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightTournamentsQuery({
 *   query: // value for 'query'
 * });
 */
export const useOutrightTournamentsQuery = useApolloQuery<OutrightTournamentsQuery, OutrightTournamentsQueryVariables>(OutrightTournamentsQueryDocument, { clientId: 'oddsApi' });
export const OutrightTournamentsSubscriptionDocument = gql`
    subscription OutrightTournamentsSubscription($query: OutrightTournamentsInputType!) {
  outrightTournaments(query: $query) {
    updated {
      ...OutrightTournamentTypeFragment
    }
    deleted {
      id
      isLive
    }
  }
}
    ${OutrightTournamentTypeFragment}`;

/**
 * __useOutrightTournamentsSubscription__
 *
 * To run a query within a Vue component, call `useOutrightTournamentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOutrightTournamentsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightTournamentsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useOutrightTournamentsSubscription = useApolloSubscription<OutrightTournamentsSubscription, OutrightTournamentsSubscriptionVariables>(OutrightTournamentsSubscriptionDocument, { clientId: 'oddsApi' });
export const SimpleEventsQueryDocument = gql`
    query SimpleEventsQuery($query: EventsInputType!) {
  events(query: $query) {
    id
  }
}
    `;

/**
 * __useSimpleEventsQuery__
 *
 * To run a query within a Vue component, call `useSimpleEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSimpleEventsQuery({
 *   query: // value for 'query'
 * });
 */
export const useSimpleEventsQuery = useApolloQuery<SimpleEventsQuery, SimpleEventsQueryVariables>(SimpleEventsQueryDocument, { clientId: 'oddsApi' });
export const TournamentEventsQueryDocument = gql`
    query TournamentEventsQuery($query: EventsInputType!) {
  events(query: $query) {
    ...TournamentEventTypeFragment
  }
}
    ${TournamentEventTypeFragment}`;

/**
 * __useTournamentEventsQuery__
 *
 * To run a query within a Vue component, call `useTournamentEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTournamentEventsQuery({
 *   query: // value for 'query'
 * });
 */
export const useTournamentEventsQuery = useApolloQuery<TournamentEventsQuery, TournamentEventsQueryVariables>(TournamentEventsQueryDocument, { clientId: 'oddsApi' });
export const TournamentEventsSubscriptionDocument = gql`
    subscription TournamentEventsSubscription($query: EventsInputType!) {
  events(query: $query) {
    updated {
      ...TournamentEventTypeFragment
    }
    deleted
  }
}
    ${TournamentEventTypeFragment}`;

/**
 * __useTournamentEventsSubscription__
 *
 * To run a query within a Vue component, call `useTournamentEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTournamentEventsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useTournamentEventsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useTournamentEventsSubscription = useApolloSubscription<TournamentEventsSubscription, TournamentEventsSubscriptionVariables>(TournamentEventsSubscriptionDocument, { clientId: 'oddsApi' });
export const DynamicMarketCountSubscriptionDocument = gql`
    subscription DynamicMarketCountSubscription($query: MarketsInputType!) {
  dynamicMarketCount(query: $query)
}
    `;

/**
 * __useDynamicMarketCountSubscription__
 *
 * To run a query within a Vue component, call `useDynamicMarketCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDynamicMarketCountSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDynamicMarketCountSubscription({
 *   query: // value for 'query'
 * });
 */
export const useDynamicMarketCountSubscription = useApolloSubscription<DynamicMarketCountSubscription, DynamicMarketCountSubscriptionVariables>(DynamicMarketCountSubscriptionDocument, { clientId: 'oddsApi' });
export const MarketsQueryDocument = gql`
    query MarketsQuery($query: MarketsInputType!) {
  markets(query: $query) {
    ...MarketTypeFragment
  }
}
    ${MarketTypeFragment}`;

/**
 * __useMarketsQuery__
 *
 * To run a query within a Vue component, call `useMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMarketsQuery({
 *   query: // value for 'query'
 * });
 */
export const useMarketsQuery = useApolloQuery<MarketsQuery, MarketsQueryVariables>(MarketsQueryDocument, { clientId: 'oddsApi' });
export const MarketsSubscriptionDocument = gql`
    subscription MarketsSubscription($query: MarketsInputType!) {
  markets(query: $query) {
    updated {
      ...MarketTypeFragment
    }
    deleted
  }
}
    ${MarketTypeFragment}`;

/**
 * __useMarketsSubscription__
 *
 * To run a query within a Vue component, call `useMarketsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMarketsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMarketsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useMarketsSubscription = useApolloSubscription<MarketsSubscription, MarketsSubscriptionVariables>(MarketsSubscriptionDocument, { clientId: 'oddsApi' });
export const MarketsV2QueryDocument = gql`
    query MarketsV2Query($query: MarketsV2InputType!) {
  marketsV2(query: $query) {
    ...MarketTypeFragment
  }
}
    ${MarketTypeFragment}`;

/**
 * __useMarketsV2Query__
 *
 * To run a query within a Vue component, call `useMarketsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMarketsV2Query` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMarketsV2Query({
 *   query: // value for 'query'
 * });
 */
export const useMarketsV2Query = useApolloQuery<MarketsV2Query, MarketsV2QueryVariables>(MarketsV2QueryDocument, { clientId: 'oddsApi' });
export const MarketsV2SubscriptionDocument = gql`
    subscription MarketsV2Subscription($query: MarketsV2InputType!) {
  marketsV2(query: $query) {
    updated {
      ...MarketTypeFragment
    }
    deleted
  }
}
    ${MarketTypeFragment}`;

/**
 * __useMarketsV2Subscription__
 *
 * To run a query within a Vue component, call `useMarketsV2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useMarketsV2Subscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useMarketsV2Subscription({
 *   query: // value for 'query'
 * });
 */
export const useMarketsV2Subscription = useApolloSubscription<MarketsV2Subscription, MarketsV2SubscriptionVariables>(MarketsV2SubscriptionDocument, { clientId: 'oddsApi' });
export const SelectionSubscriptionDocument = gql`
    subscription SelectionSubscription($query: SelectionInputType!) {
  selection(query: $query) {
    id
    marketId
    matchId
    isSuspended
    selectionTypeId
    selectionOrder
    template {
      value
      details {
        placeholder
        value
      }
    }
    price {
      value
      oddsStyle
    }
    market {
      id
      isSuspended
    }
  }
}
    `;

/**
 * __useSelectionSubscription__
 *
 * To run a query within a Vue component, call `useSelectionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSelectionSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectionSubscription({
 *   query: // value for 'query'
 * });
 */
export const useSelectionSubscription = useApolloSubscription<SelectionSubscription, SelectionSubscriptionVariables>(SelectionSubscriptionDocument, { clientId: 'oddsApi' });
export const SelectionV2SubscriptionDocument = gql`
    subscription SelectionV2Subscription($query: SelectionV2InputType!) {
  selectionV2(query: $query) {
    id
    marketId
    matchId
    isSuspended
    selectionTypeId
    selectionOrder
    template {
      value
      details {
        placeholder
        value
      }
    }
    price {
      value
      oddsStyle
    }
    market {
      id
      isSuspended
    }
  }
}
    `;

/**
 * __useSelectionV2Subscription__
 *
 * To run a query within a Vue component, call `useSelectionV2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useSelectionV2Subscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectionV2Subscription({
 *   query: // value for 'query'
 * });
 */
export const useSelectionV2Subscription = useApolloSubscription<SelectionV2Subscription, SelectionV2SubscriptionVariables>(SelectionV2SubscriptionDocument, { clientId: 'oddsApi' });
export const OddsQueryDocument = gql`
    query OddsQuery($query: EventOddsInputType!) {
  eventOdds(query: $query) {
    ...OddsTypeFragment
  }
}
    ${OddsTypeFragment}`;

/**
 * __useOddsQuery__
 *
 * To run a query within a Vue component, call `useOddsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOddsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOddsQuery({
 *   query: // value for 'query'
 * });
 */
export const useOddsQuery = useApolloQuery<OddsQuery, OddsQueryVariables>(OddsQueryDocument, { clientId: 'oddsApi' });
export const OddsSubscriptionDocument = gql`
    subscription OddsSubscription($query: EventOddsInputType!) {
  eventOdds(query: $query) {
    updated {
      ...OddsTypeFragment
    }
    deleted
  }
}
    ${OddsTypeFragment}`;

/**
 * __useOddsSubscription__
 *
 * To run a query within a Vue component, call `useOddsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOddsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOddsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useOddsSubscription = useApolloSubscription<OddsSubscription, OddsSubscriptionVariables>(OddsSubscriptionDocument, { clientId: 'oddsApi' });
export const OutrightsQueryDocument = gql`
    query OutrightsQuery($query: OutrightsInputType!) {
  outrights(query: $query) {
    ...OutrightTypeFragment
  }
}
    ${OutrightTypeFragment}`;

/**
 * __useOutrightsQuery__
 *
 * To run a query within a Vue component, call `useOutrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutrightsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightsQuery({
 *   query: // value for 'query'
 * });
 */
export const useOutrightsQuery = useApolloQuery<OutrightsQuery, OutrightsQueryVariables>(OutrightsQueryDocument, { clientId: 'oddsApi' });
export const OutrightsSubscriptionDocument = gql`
    subscription OutrightsSubscription($query: OutrightsInputType!) {
  outrights(query: $query) {
    updated {
      ...OutrightTypeFragment
    }
    deleted
  }
}
    ${OutrightTypeFragment}`;

/**
 * __useOutrightsSubscription__
 *
 * To run a query within a Vue component, call `useOutrightsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOutrightsSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOutrightsSubscription({
 *   query: // value for 'query'
 * });
 */
export const useOutrightsSubscription = useApolloSubscription<OutrightsSubscription, OutrightsSubscriptionVariables>(OutrightsSubscriptionDocument, { clientId: 'oddsApi' });
export const CurrentTournamentsQueryDocument = gql`
    query CurrentTournamentsQuery($query: SportInputType!) {
  currentTournaments(query: $query) {
    ...CurrentTournamentsFragment
  }
}
    ${CurrentTournamentsFragment}`;

/**
 * __useCurrentTournamentsQuery__
 *
 * To run a query within a Vue component, call `useCurrentTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTournamentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentTournamentsQuery({
 *   query: // value for 'query'
 * });
 */
export const useCurrentTournamentsQuery = useApolloQuery<CurrentTournamentsQuery, CurrentTournamentsQueryVariables>(CurrentTournamentsQueryDocument, { clientId: 'oddsApi' });
export const TournamentGroupsQueryDocument = gql`
    query TournamentGroupsQuery($query: TournamentGroupsInputType!) {
  tournamentGroups(query: $query) {
    groupName
    teamList {
      id
      teamName {
        language
        value
      }
      countryName
      played
      won
      drawn
      lost
      goalDifference
      points
      ranking
      isQualified
    }
  }
}
    `;

/**
 * __useTournamentGroupsQuery__
 *
 * To run a query within a Vue component, call `useTournamentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTournamentGroupsQuery({
 *   query: // value for 'query'
 * });
 */
export const useTournamentGroupsQuery = useApolloQuery<TournamentGroupsQuery, TournamentGroupsQueryVariables>(TournamentGroupsQueryDocument, { clientId: 'oddsApi' });
export const TournamentKnockoutQueryDocument = gql`
    query TournamentKnockoutQuery($query: TournamentKnockoutInputType!) {
  tournamentKnockout(query: $query) {
    ...KnockoutFragment
  }
}
    ${KnockoutFragment}`;

/**
 * __useTournamentKnockoutQuery__
 *
 * To run a query within a Vue component, call `useTournamentKnockoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useTournamentKnockoutQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTournamentKnockoutQuery({
 *   query: // value for 'query'
 * });
 */
export const useTournamentKnockoutQuery = useApolloQuery<TournamentKnockoutQuery, TournamentKnockoutQueryVariables>(TournamentKnockoutQueryDocument, { clientId: 'oddsApi' });